<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-green interview-title">
					Day 4 - The South Pacific
				</h1>
				<h1 v-else class="band-color-green interview-title-sm">
					Day 4 - The South Pacific
				</h1>
			</v-col>
			<v-col>
				<p class="band-color-green word-salad">
					(The Art of Doing Nothing, Hello Mr. President, Prelude To A Bigger Scandal, Headwaters To Spygate, Free Climbing, Waking Up A Bear, Pirates Of The Caribbean, Hillary’s Paranoia, Wiretapping Trump, It’s A Man Thing, Marlon Brando, The Man With The Golden Goose, Watching My Captor, Gang Of Thugs, Easier Said Than Done, Oahu Snub, Come Together, How To Work A Room: Abused Child Edition, Workin’ Hard-Playin’ Hard, A Strange Silence, Sleeping With The Enemy, Strange Vibes, Even The President Needs Passion, Flipping The Switch, What Happens On The Boat Stays On The Boat, All Bets Are Off, Invisible Enemy, Parasite Detection Tool, In The Middle Of Nowhere, The Broken Triangle, Tom Hagan, A Virgin Suicide, Deterioration Of A President, No Loitering Here, Burning Down The House, Surveillance Withdrawals, Tender Trap, Disintegration, Don’t Fuck With The King, Face The Music, Travelin Man, Getting Away With It All Messed Up, Art Of The Steal, Not Your Handyman, Prelude To A Stalker, Such A Shame, King Of The Room, Exposing The Infection, Omaha Oligarch, Can’t Get A Signal, Communication Breakdown, Just Another Gas Leak, Billionaire Reading List, Miss Misery, Runaway, Hillary’s Human Shield, Increased Surveillance, Escape From Suicide Island, Battlefield Salute, Frank Pentangeli, Celebrity Rescue, Broken Toys, Leaving Crumbs, Livin' Thing and more …… See Timeline for Chronology of Events)
				</p>
			</v-col>
			<v-col cols="12" class="main-text text-border">
				<p class="h-l">
	H.L. Are you ready to go today?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, definitely.
</p>
<p class="h-l">
	H.L. Let’s recap the timeline here. You are in Missouri; it is the winter of 2016.
</p>
<p>
<span class="douglas">Douglas:</span> Okay, February of 2016. We arrived at the Missouri house in the summer of 2015. My original intention was to slow down, to decrease the marketing of <span class="italic">The Legacy Letter</span>. But that is not what happened. For the final six months of 2015, I sent out close to 5000 copies of it. We have been over that already.
<span class="break"></span>
However, by February of 2016 I was essentially finished with sending out <span class="italic">The Legacy Letter</span> altogether.
</p>
<p class="h-l">
	H.L. You say ‘we’. It may be a good time to introduce your ‘friends’ to the readers. As you will need to clarify their involvement as they do play some role in the events we are speaking of today.
</p>
<p>
<span class="douglas">Douglas:</span> Sure. Well, I was in Missouri with my girlfriend and her daughter. She is now my ex-girlfriend.
</p>
<p class="h-l">
	H.L. This is who was with you in Tennessee?
</p>
<p>
<span class="douglas">Douglas:</span> Yes in fact through all the events we speak of over these six days; she is the one. Obviously I wanted to keep them out of it, but as you said, today she will play a part.
<span class="break"></span>
At the same time it was not a stretch to define her as a friend more than as a girlfriend. While we were somewhat close periodically, it was always well understood by me that as soon as it was possible for her to do so, she would be returning to Southern California; as that is where the school system or school district she wanted her daughter to finish out school in was located.
<span class="break"></span>
It was also understood that when she moved, I would move to Europe to be close to my children.
</p>
<p class="h-l">
	H.L. Both of your priorities were your children, but they would ultimately take you in different directions.
</p>
<p>
<span class="douglas">Douglas:</span> Yes. Well, something close to that.
</p>
<p class="h-l">
	H.L. So by February of 2016 you were just about finished with <span class="italic">The Legacy Letter</span>, and doing very little. Correct?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and there was a very good reason for this: election season. I feared this election, because I knew that many of my potential donors were also very big political donors. So I believed the politicians would compete for the discretionary charity or interest I might receive. So to me it was a wash.
<span class="break"></span>
In fact after the middle of February 2016, I stopped sending out emailed copies of <span class="italic">The Legacy Letter</span> all together; this until well after the election, a date still many months away.
<span class="break"></span>
Even after the election I just sent a few to people that I had missed years earlier. It was basically over in mid February, I had sent out over 10,000 emails. Indeed there were very few of the wealthy and powerful around the world that did not know about The Theorem at this time. I had completed some of my job at least, and was looking to the future.
</p>
<p class="h-l">
	H.L. I imagine you were tired, two years, even intermittently, is a long time to sit in front of a computer. Especially when you are not getting the results you want. But like you said, you made a lot of friends.
</p>
<p>
<span class="douglas">Douglas:</span> I did make a lot of friends, and that is really what I consider them to be to this day. I mean all of them; I wouldn’t have sent a copy of <span class="italic">The Legacy Letter</span> to these people if I didn’t like them. Even though some aligned against me, I understand it was only business. I still like them today. I may have regretted sending maybe 10 Legacy Letters out of the 10,000, so that’s a good ratio.
</p>
<p class="h-l">
	H.L. Not bad at all.
</p>
<p>
<span class="douglas">Douglas:</span> You know one last thing; American business is really such a class act. Everyone was so respectful to me. In some ways, I was envious I didn’t choose that field. In all the phone calls, and the annoying follow-up emails I must have sent, even during market (stock) hours these guys would take the time to read my communications. I really think in the thousands of communications and calls, I never met a rude voice or reply. I just fell in love with them. That’s the truth; they are a true class act!
</p>
<p class="h-l">
	H.L. That’s great. Still that is great exposure for your book.
</p>
<p>
<span class="douglas">Douglas:</span> It was and is, sure. But like everything else it was the people, the ones you meet that make everything worth it.
<span class="break"></span>
So anyways, out of the 10,000 Legacy Letters I sent out to potential donors or investors, one of them I sent out was to Donald Trump. Of course he was a billionaire, so he was in my sights. I believe it was in early 2014, maybe it was spring. It was a very long time ago. Way before the 2016 political season began.
<span class="break"></span>
	As you know I was very good at determining who was coming to my website, who had interest and who did not. Donald Trump did not have any interest.
<span class="break"></span>
It was more than that. I didn’t even see any evidence that he had read the letter. He was essentially invisible to my search, my technique and to everything. And if there is one thing that now President Trump is not, it’s invisible.
</p>
<p class="h-l">
	H.L. Yes, I think you would have known, he has a big media presence.
</p>
<p>
<span class="douglas">Douglas:</span> I was only mildly discouraged however, because not only were there a lot of other billionaires, but also he was a celebrity billionaire. Like I said, I didn’t want any celebrity getting hurt by this controversial book and discovery in any way.
</p>
<p class="h-l">
	H.L. Especially a rich one!
</p>
<p>
<span class="douglas">Douglas:</span> You’re right, that’s a good point, especially a rich one.
<span class="break"></span>
Still, I liked Donald Trump and even though I didn’t think he would be a fit, I wanted him to read <span class="italic">The Legacy Letter</span> I was so proud of.
<span class="break"></span>
So I did something I rarely do; I sent him a duplicate copy a few months later. I figured maybe the first copy was chewed up in his expensive server or something. Still, I received no indication. He was still invisible to my search. So I assumed the obvious; he wasn’t interested.
</p>
<p class="h-l">
	H.L. So you were disappointed?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I was because when I was much younger and was in business, I was a fan of his. I had even read his first book, and I enjoyed it. I think I received it as a gift for Christmas.
<span class="break"></span>
Years later when he had all those bankruptcy issues, and you didn’t hear about him as much, I said to myself, he will be back. I felt, as I think many did, he would go get his house in order and then come back stronger than ever.
<span class="break"></span>
	Of course that is what happened. In the many years that followed however, I never had a television so I never watched The Apprentice or the celebrity version. However, once in a motel I watched an episode and was quite impressed. He had matured into quite an effective leader I felt.
</p>
<p class="h-l">
	H.L. You know that’s a good point, the Celebrity Apprentice; imagine dealing with all those big egos? You would have to learn a lot about people, and about yourself.
</p>
<p>
<span class="douglas">Douglas:</span> Basically, that’s how I saw it. He had definitely changed, and for the better.
<span class="break"></span>
But he wasn’t interested in my letter, so I moved on. Again, in 2014, I was very busy surviving. Still over the following year and a half, I saw no interest from Donald Trump.
<span class="break"></span>
Then it all changed, and I mean it changed overnight. It took over two years, but it changed.
<span class="break"></span>
Here is where the story is going to get even more bizarre.
</p>
<p class="h-l">
	H.L. Is that even possible?
</p>
<p>
<span class="douglas">Douglas:</span> It is, and it will.
<span class="break"></span>
When you do something like I was doing for a long time, and that’s all you do, you get very tuned in to different aspects of doing it.
<span class="break"></span>
In other words, in the beginning, back in 2014, I had no idea if the potential investors were even interested. Over time by developing my detection tool, speaking to them on the phone and receiving their replies, I was able to get a sense of what their perceptions were.
</p>
<p class="h-l">
	H.L. Of course, most everyone develops that.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well after nearly two and a half years I was almost an expert at this skill.
<span class="break"></span>
I could essentially ‘feel’ by someone’s behavior on the internet and related to my search where their head was at in regards to <span class="italic">The Legacy Letter</span> and The Theorem in general. So by now I would analyze the patterns of their behavior and was further developing an intuitive sense. Sometimes I was incorrect in my perceptions and assumptions, but most of the times I was right.
</p>
<p class="h-l">
	H.L. Understood.
</p>
<p>
<span class="douglas">Douglas:</span> I am explaining all of this because the pattern I noticed with Donald Trump’s presence was unlike any I had ever seen before. Now I don’t know if it was him, or those closely associated to him, but they were at my website for a substantial amount of time; and their presence kept growing and growing.
<span class="break"></span>
Now if this would have been anyone else, anyone not in the middle of a presidential campaign, I would have been convinced that they were on the brink of investing.
</p>
<p class="h-l">
	H.L. That makes sense; though not in the middle of a presidential campaign.
</p>
<p>
<span class="douglas">Douglas:</span> At first I was convinced I was misinterpreting the data. This was my initial denial, where I hid from the reality of what was going on.
<span class="break"></span>
It was logical; he was all over the news. So I adjusted my detection tool back, as far as I have ever gone with a public individual: Still no change.
<span class="break"></span>
I then did something I never do: I went and checked my interpretations against a public computer; paid cash, no login, nothing. So, essentially I had a clean and invisible search; then I contrasted that with my own personal findings.
<span class="break"></span>
Finally, I went even one step beyond that. I scaled back my model even further; still my readings were off the charts.
<span class="break"></span>
Something was happening.
</p>
<p class="h-l">
	H.L. Yes, to go that far you must have been puzzled.
</p>
<p>
<span class="douglas">Douglas:</span> I really was. The second explanation was more practical. Perhaps he just had not read it yet. Now this happened occasionally, these guys are very busy and once in awhile I am surprised, as I will notice a first view a full two years after I sent the email.
<span class="break"></span>
In that case the letter had to typically be fished out of the spam folder. So I was relieved for awhile that this was the logical reason.  Still that didn’t make sense; there were those who knew him and who had received <span class="italic">The Legacy Letter</span> and were interested. I will not go into details. But, it was puzzling to me.
<span class="break"></span>
So I just let it pass, and figured; well maybe he just read it for the first time and it is motivating him. I felt proud it was motivating a presidential candidate. This belief was actually not a stretch, I could see from many of the men’s behavior after they received <span class="italic">The Legacy Letter</span> that they had taken bold action in their lives. Actually it was quite common. The letter was challenging, it would tug deep at the very soul of the motivation that defined them. So I could live with that.
</p>
<p class="h-l">
	H.L. That was your summation of the situation?
</p>
<p>
<span class="douglas">Douglas:</span> For a minute, maybe two.
<span class="break"></span>
There were a couple of problems with this assessment however. The first was that this was going on at the same time the surveillance was ratcheting up in intensity.
</p>
<p class="h-l">
	H.L. So you had heavy surveillance in Missouri as well? Not just in Tennessee. Please explain.
</p>
<p>
<span class="douglas">Douglas:</span> Well, I didn’t want to go into this again, especially after what we talked about yesterday, but yes. It had been going on since Barack Obama took office. I only bring this up now because never since 2008 had I experienced surveillance of the level I experienced it from the spring of 2016 to the election. Never in Tennessee, never when traveling internationally; nowhere, at any time was it even close to what I was about to be confronted with.
</p>
<p class="h-l">
	H.L. That is very unusual. Could you provide some details?
</p>
<p>
<span class="douglas">Douglas:</span> Sure.
<span class="break"></span>
Every time I would try and get the local Missouri weather on my phone, all it would pull up was Washington D.C.
<span class="break"></span>
That by itself was not impressive, but when you add it to the same exact repairman who fixes your cable, your power lines and works for the gas company you have to start and wonder. At first you say, well, he must have two or even three jobs. Then you ask around about him to the real repair workers and no one has ever heard of this guy.
<span class="break"></span>
He wasn’t the only suspicious ‘repairman’ either. As it seemed like every week during the spring and summer of 2016 repair workers were looking for an excuse to get under our house, in the basement or on the roof for something. And none of them looked like repair people, all looked like recent graduates from the FBI academy. The list goes on and on; we thought we had a Peeping Tom(s), you couldn’t get a phone signal; Bluetooth wouldn’t happen, the internet went out every other week.
<span class="break"></span>
It became even more bizarre. They moved everyone out of the apartment complex across the street, it was a large operation. Seemingly there was nothing wrong with the apartments at all, but after moving everyone out of there they just leveled it all to the ground; in a town where they never do that. It was almost as if to get a better view of our property, which was of course then possible with those apartments out of the way.
<span class="break"></span>
Also, when we had moved in, and because we were on the main street of town, there was a large amount of vagrancy foot traffic; well, in the spring of 2015 those people suddenly vanished. And in their place were parked surveillance vehicles. Now this alone was not remarkable to us by this time, but it was the arrogance, the overt nature of the surveillance that gained the attention of even those neighbors who had been the least inquisitive previously.
<span class="break"></span>
This all culminated, and ceased, the day after the election, with an event we will get into later.
</p>
<p class="h-l">
	H.L. In essence, they made life less bearable, and it seemed they wanted you to know they were there.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but only from the spring of 2016 until the election. Then it was the quietist house on the block. Go figure.
</p>
<p class="h-l">
	H.L. What month was this?
</p>
<p>
<span class="douglas">Douglas:</span> Well I didn’t take notes, but I am sure it was at least five months before the election, maybe even six, but it could have been more.  If I had to guess: April or May of 2016. But it was definitely a gradual though rapidly accelerating progression.
</p>
<p class="h-l">
	H.L. Thanks, just keeping the timeline straight. That is unusual, because like you said you were doing very little in that time.
</p>
<p>
<span class="douglas">Douglas:</span> I was doing absolutely nothing really, especially in regards to the potential investors, nothing at all. Watching baseball and the election news and that’s it.
</p>
<p class="h-l">
	H.L. You said there were two problems in your dismissal of Candidate Trump’s interest. What was the other?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, thank you. The other problem was the presence I felt. And this goes back to being perceptive with your craft.
</p>
<p class="h-l">
	H.L. Okay.
</p>
<p>
<span class="douglas">Douglas:</span> It just seemed like the pattern was not a good pattern with Donald Trump. It seemed somewhat negative. It didn’t feel like: “This is great; I am interested!” It wasn’t like that at all.
</p>
<p class="h-l">
	H.L. Oh really?
</p>
<p>
<span class="douglas">Douglas:</span> The best analogy I can give, and it never really escapes my mind, is that of me waking up a bear out of hibernation. The reason it doesn’t escape my mind is because it fit so perfectly.
<span class="break"></span>
The vibe I felt was, “Who are you, and why are you in the middle of my campaign for President?” It was very bearish, and again, unique to 10,000 other perceptions. I had never experienced that with anyone.
</p>
<p class="h-l">
	H.L. That does sound a bit strange; your perception regarding his reaction.
</p>
<p>
<span class="douglas">Douglas:</span> It was. The thing is that it never went away. I mean all the way through the election cycle, not only the Trump Team’s increase in traffic but also that eerie feeling I had. So while I was rooting for Donald Trump, with every particle that was in me, I also had an uneasy feeling.
<span class="break"></span>
It just didn’t make any sense. It didn’t make any sense the same way the extra surveillance didn’t make any sense. But I had that feeling in the pit of my stomach that something was going on and I was involved in it, however I couldn’t define it.
</p>
<p class="h-l">
	H.L. So it’s summer of 2016, you are doing nothing as you said, but either Donald Trump or someone from his election campaign is at your website all the time, or at least heavily. At the same time, all of this surveillance is going on around you and you are completely confused by it; sounds wild.
</p>
<p>
<span class="douglas">Douglas:</span> It took me until the morning after the election to assimilate all the events that had been occurring for the past six months, until I could begin piecing them together and finally make some sense of it all.
</p>
<p class="h-l">
	H.L. Great, go on. Some clarity would be welcomed
</p>
<p>
<span class="douglas">Douglas:</span> Well we have to go back to the beginning of the year with Barack Obama to understand this. Now remember I am emailing, sending out Legacy Letters, all the way until February 2016. After that however, it would have been clear to anyone listening, which they were, I was done.
<span class="break"></span>
So by March 2016 Barack Obama had to feeling good about himself, about life in general, especially in regards to his suppression efforts in regards to The Theorem and <span class="italic">The Legacy Letter</span>.
<span class="break"></span>
He was getting a long earned reprieve from suppressing it. After all, 2015 had been a brutal year, he was bombarded by disappointing perceptions, and sleep interrupted nights. It didn’t help when I moved into the Missouri house in the summer of 2015 and started emailing again. He thought this nightmare would begin all over again. But it didn’t.
<span class="break"></span>
So by March of 2016, he prided himself that he had all but squashed my attempts to gain investment in The Theorem, and to be honest he had; crisis averted, mission accomplished.
</p>
<p class="h-l">
	H.L. Mission accomplished always sounds ominous.
</p>
<p>
<span class="douglas">Douglas:</span> Anyways, after he realized that our television was not on to hide sinister background communication, but that I was actually watching it, he could relax. He realized that I was taking some time off and doing little. The bedrock of this realization was that he had seen me do this before. He knew that I took my rest as serious as my work.
<span class="break"></span>
With the release of this burden he began to do what he needed to do, go fill up his coffers of self-confidence. To accomplish this he would take a trip down memory lane of international travel and go soak up some of the adoration he had received early in his presidency.
</p>
<p class="h-l">
	H.L. He was busy.
</p>
<p>
<span class="douglas">Douglas:</span> He was, very busy: he would visit Cuba, South America, Europe and even Asia all before the summer of 2016. Besides the expected adoration, he could make sure and be close enough to stomp out the embers that remained from the fire of international interest in The Theorem that was there just a year before.
<span class="break"></span>
So the trips made sense; likely many were promised secretly back in 2015 in order to pacify the leaders who then had to return to their billionaires with the bad news: they couldn’t invest in the largest psychological discovery in human history. It was a party they had to sit out.
</p>
<p class="h-l">
	H.L. Seems logical. He was busy, so he made all of those trips in the beginning of 2016?
</p>
<p>
<span class="douglas">Douglas:</span> Yes. Now during that time, away from The White House I believe he stopped checking in on me, as Barack Obama somewhat disappeared from the tool I was using to determine my visitors. He could have been masked to a greater extent, but typically I could determine those times as well.
<span class="break"></span>
So now in the summer of 2016, he is back in Washington D.C. He will take a quick trip to Canada and one to Europe, but besides that he is the US. He will also meet with Hillary Clinton, to help her campaign in July. He will not leave the U.S. until September for China.
<span class="break"></span>
This is what I believe to be an accurate representation of events, as I could interpret them from all the tools I utilized and the power of observation as to what was going on around me.
</p>
<p class="h-l">
	H.L. Sure, I welcome it.
</p>
<p>
<span class="douglas">Douglas:</span> Sometime in the spring of 2016, somebody tipped off Donald Trump as to what had been going on with Obama and Clinton’s suppression of The Theorem and <span class="italic">The Legacy Letter</span>. It could have been a campaign aide; it could have been the Secret Service. It could have been anyone. It was more likely a source that told a source.
<span class="break"></span>
Still it was damning evidence against Hillary Clinton. Now Donald Trump really didn’t want to get involved in anything that could risk him his campaign, the potential presidency and his real estate empire.
</p>
<p class="h-l">
	H.L. The intrigue is building, go on.
</p>
<p>
<span class="douglas">Douglas:</span> But that doesn’t stop him from being curious; this scandal sounds like a big deal. But how could he prove it? He did not have the intelligence connections to do so. So he quickly decides to drop it, kind of.
</p>
<p class="h-l">
	H.L. Kind of?
</p>
<p>
<span class="douglas">Douglas:</span> He is still interested in what makes Hillary Clinton and Barack Obama so focused, almost obsessed on this. He can’t dismiss it. He is on the outside of the information, and there is one thing he does not like to be and that is the outside of the information. He is a billionaire and part of being a billionaire is having good intelligence about those around you or those you are competing against.
<span class="break"></span>
That’s normal, as long as information is collected in a legal manner it is allowed, and Donald Trump, at this stage of his life, will only collect his information in a legal manner. Trust me on this.
</p>
<p class="h-l">
	H.L. Starting to come together. So he was still interested in coming to your site though?
</p>
<p>
<span class="douglas">Douglas:</span> Sure, someone from their campaign was, this is a new development. You never know, I might publish something he can use. So they are there often. This is how he sees it. I mean, if I expose this scandal he can tap dance into The White House.
</p>
<p class="h-l">
	H. L. Got it. But you don’t.
</p>
<p>
<span class="douglas">Douglas:</span> No, I don’t because at this point I don’t have a clue of what is going on between these three players; Barack Obama, Hillary Clinton and Donald Trump.
<span class="break"></span>
Candidate Trump knows way more about it than I do, and he’s in the dark at this stage.
</p>
<p class="h-l">
	H.L. You said you felt he was angry when he came to your site, this doesn’t make sense though.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, I can explain.
<span class="break"></span>
In response to Donald Trump’s interest in this newly uncovered scandal, Barack Obama plants a spy inside the Trump Campaign. He also plants a false narrative that I am working with Obama, or Clinton.
<span class="break"></span>
Now you have to realize something. By summer of 2016 it was the worst kept secret in the financial community that my potential investors were being targeted; and targeted severely. In fact it was likely even known well before this, as the response I was getting towards the end of 2015 from Legacy Letter recipients was much less enthusiastic than before. In addition to the election, the lack of excited responses was one of the reasons that I stopped sending them out altogether in February of 2016.
<span class="break"></span>
So Obama is very crafty here. He uses this assumption that his administration is targeting my potential investors in his favor. He spins it clear around, and lets it be known that I am somehow responsible for the prosecutions of these high-net worth individuals.
<span class="break"></span>
Now, Donald Trump doesn’t fall for it. He’s pretty the sure the tip is false, that it is a plant. He also knows Obama and likely Clinton have spies in there, amongst his campaign team. But Obama’s strategy works well enough, this false narrative plant, to give Donald Trump a moment of pause.
</p>
<p class="h-l">
	H.L. I heard he said that he had a spy on his campaign.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and let me tell you more.
<span class="break"></span>
If Donald Trump thought there was a spy in there, there was one. Because he has some of the best instincts I have seen in a billionaire. He really does, and I have been indirectly studying many of them for five years now. Not business instincts, or solely political instincts, but aggregate instincts about everything. They are highly attuned within him.
<span class="break"></span>
Still he is not sure. When you are dealing with spies you never really are. Who knows what they mean? So he is cautious, curious and reserved. That is what I was feeling.
</p>
<p class="h-l">
	H.L. That makes sense.
</p>
<p>
<span class="douglas">Douglas:</span> Here Obama overestimates me and begins misinterpreting events.
<span class="break"></span>
He sees this increased traffic by the Trump Team as verification that I am up to something with candidate Trump. He increases my surveillance. Then he makes the second biggest mistake of his political career and starts surveillance on Trump Tower. Or at the very least he increases the surveillance on Trump Towers which of course is the wiretapping.
</p>
<p class="h-l">
	H.L. That is just bizarre, all of this in the middle of Hillary Clinton’s Presidential Campaign.
</p>
<p>
<span class="douglas">Douglas:</span> It is unlikely Obama told Hillary Clinton about the Trump surveillance until July 5th, when he met with her for a campaign rally. He may have, who knows. But somehow she found out; and likely before July.
</p>
<p class="h-l">
	H.L. Keep Going.
</p>
<p>
<span class="douglas">Douglas:</span> Now Hillary Clinton is not so stupid as to put direct surveillance on Donald Trump’s residence or campaign, but she is getting a little uncomfortable that Barack Obama has her fate in his hands.
<span class="break"></span>
After all she is embattled with the email scandal, and she could fall any day. So she’s not quite her cool and calm self. Now unlike how it usually works, where Bill sends Hillary out to conquer the world, this time it is different.
<span class="break"></span>
Hillary dispatches Bill to meet with Loretta Lynch on the airport tarmac in Arizona to see what she knows; and to also have her water down Hillary’s email scandal. This happens on June, 27th 2016. Lynch doesn’t give Bill Clinton the information he wants, and now distrust is starting to build between one-time allies; between Obama and the Clintons.
</p>
<p class="h-l">
	H.L. This alone shows you there is tension between the Clintons and Obama at this time. Or even distrust as you say.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, very observant, excellent. Otherwise Bill Clinton would have just made another surprise visit to meet with Obama at The White House or somewhere else and received the information directly from Obama.
</p>
<p class="h-l">
	H.L. No one would have thought a thing about it as his wife is in the middle of a presidential campaign, it would not have been a big deal.
</p>
<p>
<span class="douglas">Douglas:</span> True. But basically the Clintons are on their own at this point. Likely Donald Trump’s evidence in regards to the scandal is pointed towards Hillary Clinton at this time, rather than focusing on Barack Obama.
</p>
<p class="h-l">
	H.L. Sure that is where his interests are.
</p>
<p>
<span class="douglas">Douglas:</span> So the tension is really ratcheting up between them, all are in the dark as to what the other one knows, who is going to go down; what cards does Donald Trump hold, what cards do I hold, are candidate Trump and me working as a team? This was all circulating in an ever accelerating whirlpool in the late summer of 2016.
</p>
<p class="h-l">
	H.L It all ties together. Good.
</p>
<p>
<span class="douglas">Douglas:</span> So Hillary Clinton is hungry for information. Now in this loop between Obama’s obsession with <span class="italic">The Legacy Letter</span> and The Theorem, and his growing obsession with Donald Trump’s candidacy; I am the lowest risk to scour information out of. So she starts surveillance on me, hoping that if there is something going on, I will be careless and spill it.
</p>
<p class="h-l">
	H.L. Looking back to Tennessee and the stunt you played with the US Africa Aid, this is all starting to make sense. Barack Obama now has no real idea what you are doing.
	<span class="break"></span>
Do you think that your lack of activity in Missouri made President Obama suspicious? Perhaps doing nothing, was speaking volumes.
</p>
<p>
<span class="douglas">Douglas:</span> I think that was a big part of it. Certainly if you are focused on something for a long period of time such as he was with my surveillance, then you leave it, and come back later to resume it, there could have been that natural tendency to believe you missed something.
<span class="break"></span>
This, in and of itself could have caused him some small panic. My lack of activity could have fed into this.
</p>
<p class="h-l">
	H.L. So he is away on his International Travels that spring (2016) and comes back and all of a sudden it’s like, what did I miss? I can see how someone’s mind works that way. I have noticed that behavior in myself and others.
</p>
<p>
<span class="douglas">Douglas:</span> Sure it’s common. Almost like, “Okay now it’s time to buckle down on my work.” Hence, partially explaining the increased surveillance I was realizing.
</p>
<p class="h-l">
	H.L. But nothing was going on?
</p>
<p>
<span class="douglas">Douglas:</span> Not on my end, nothing. I am in the dark. So what I misinterpret as increased surveillance from the Obama Administration could very likely be nothing more than two distinct entities conducting the surveillance.
</p>
<p class="h-l">
	H.L.  Why did you believe it was two?
</p>
<p>
<span class="douglas">Douglas:</span> Well, I was getting to that.
<span class="break"></span>
On the morning after the election, I was up early. I was heading to the gym or to go running. I went outside my house and noticed something very strange. This was close to 7 a.m. I will tell you why I remember almost the exact time and definitely the exact day.
<span class="break"></span>
I know it was the day I was to work my legs, and like everyone else, leg days are painful. So I was looking for an excuse not to go; I had one too.
<span class="break"></span>
I had been up late watching the election results. Still, I said to myself that it was Donald Trump’s victory now go make your own! I remember most of this like it is yesterday, it is that clear. But here is what I stumbled upon:
<span class="break"></span>
Now by this time I mostly knew who our utility workers were. I also knew which ones worked for Obama’s surveillance team, whatever branch he had conducting them; I believe it was some subcontractor for the NSA. On this morning, Wednesday November 9th, 2016, these were two workers I had never seen before.
<span class="break"></span>
Typically our real utility guys start their day like this. They have a cup of coffee around 8:30 am. Then they talk until about 9am. Then they slowly get their cherry picker or crane in place, put their cones down and slowly get up to the pole. I’m not putting them down, our guys were great; when we had a power outage, internet problem or whatever, they were right there. But again, this is a very small town, and everyone knew everyone. I think it would be stretching it to say we had 3000 people living there.
<span class="break"></span>
Also I had never seen our utility guys operate without a crane or a cherry picker. I had never seen them free climbing a pole. I am not saying they couldn’t, but it would be a challenge for them. Do you get my point?
</p>
<p class="h-l">
	H.L. Yes, I do. So these guys were free climbing the poles?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, now I didn’t see them climbing up the pole, but there was no cherry picker or crane anywhere in the vicinity. I just assumed it would be an unlikely scenario for a crane to lift them up to the top of the pole and then drive off.
</p>
<p class="h-l">
	H.L. No I doubt that would happen.
</p>
<p>
<span class="douglas">Douglas:</span> But I did see one of them scurrying down. The other was already down just departing the pole with a small box in his hand; but again no cherry picker or crane on his pole either. His box was the same color as his pole.
<span class="break"></span>
But here is the thing; the two guys were not together. They were essentially competitors. I know it sounds strange, but they never acknowledged each other’s presence. They eventually drove away in different directions.
<span class="break"></span>
You’ll have to trust me on this, but you could tell they were in a type of professional competition. It was just so bizarre.
<span class="break"></span>
But the guy I saw coming down the other pole, the one on the northwestern end of our property, saw me and slipped. I caught him straight away. I saw him slip his box, the back of it, into his pouch and try and hide it. I really had him busted, and if I wasn’t so groggy, I may have even approached him. Also, his box was not the same color or type as the other guy’s box who had just come down from the other pole.
<span class="break"></span>
I wasn’t supposed to be up that early, they knew my schedule. I usually worked out later, but I had things to do that day and wanted to get out before my other duties and responsibilities.
<span class="break"></span>
But I have never seen anyone come down a pole like that; it was like one of those logger or lumberjack competitions, these guys were real pros. At least the one I caught was.
</p>
<p class="h-l">
	H.L. That is very unusual. So what did you do?
</p>
<p>
<span class="douglas">Douglas:</span> Well, I went into my car, sat down and then it all hit me. I was processing months and months of confusion that finally now had a tail. I literally became dizzy as it all came together for me. I say all, because to me that was all I knew at the time. But I would learn and assimilate much more at a later time.
<span class="break"></span>
This was a big piece of the puzzle however. I knew it had something to do with the election, and it confirmed my belief that I was indeed under surveillance by more than one entity. It was a big find.
</p>
<p class="h-l">
	H.L. They lost the election and they wanted the surveillance out right now!
</p>
<p>
<span class="douglas">Douglas:</span> That’s it; I knew it was over for them. I knew, or at least I thought I would be a free man soon. I was convinced this nightmare I had endured was over.
<span class="break"></span>
I was wrong. Actually I was just getting deeper and deeper. But it was a relief. At this point, the only thing I didn’t understand was exactly our new president elect’s role, if any in this. I was so happy though and so excited Donald Trump was the new president; as you would imagine. He had really beaten those crooks!
</p>
<p class="h-l">
	H.L. I can imagine. I think many were.
</p>
<p>
<span class="douglas">Douglas:</span> So now we have to go back, we have to rewind.
</p>
<p class="h-l">
	H.L. Okay. So Hillary Clinton put’s surveillance on you.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, there we are. Thank you.
<span class="break"></span>
In early July she meets with Obama at her rally and they discuss the information and the suspicions keep growing between them. Obama finds out about Clinton’s surveillance, but says nothing. You see they are all starting to run for cover. They are thinking about the exit strategy in case this all goes south. One does not trust the other. Their partnership is fraying.
<span class="break"></span>
Also Obama is fraying, from here on in he will be lashing out at candidate Trump. But at the same time he is not really supporting Hillary Clinton by showing up at rallies either. Things are heating up, and we start to see his pattern subtly emerge. He likes to run, when he believes he will be in trouble.
</p>
<p class="h-l">
	H.L. Meanwhile Donald Trump is realizing he has surveillance.
</p>
<p>
<span class="douglas">Douglas:</span> Sure he is. In fact this likely came way earlier, probably right away after President Obama found out Donald Trump had the information about Hillary and his mischievous attempts to suppress The Theorem; whenever that was.
<span class="break"></span>
It is also critical to realize that I may be off a couple of months on my projections. In some ways, I think Trump Tower was under surveillance earlier, and just maybe our surveillance was ratcheted up earlier too. You know obviously I wish looking back I would have taken notes; I really wish I could go back in time and look with my eyes today and memorize every event, as they are all so important.
</p>
<p class="h-l">
	H.L. Sure, it doesn’t work like that though.
</p>
<p>
<span class="douglas">Douglas:</span> Okay one more thing about the surveillance on Trump Towers.
</p>
<p class="h-l">
	H.L. Go ahead.
</p>
<p>
<span class="douglas">Douglas:</span> Now when Donald Trump says he is under surveillance there are some things you need to know about that disclosure.
<span class="break"></span>
The first things are his opinions of it. While I share very few qualities with President Trump I think there is one that I do. I may be stretching my assumptions a little bit, but I think I can see his perspective.
<span class="break"></span>
Like myself, I think that when candidate Trump realized he was under surveillance, he didn’t care: to a point. In other words he was probably like well this is how politics works; as long as they are watching and I’m not watching them, they can eat my dust!
I know that’s an antiquated statement, but it applies. He likes to be the lead dog essentially. I doubt he will ever be very good at surveillance or having any real interest in it. That is a welcome thing for our country right now; I know you can see why.
</p>
<p class="h-l">
	H.L. That makes sense; he would have come forward earlier if it really bothered him. Yes, also like you said it makes you too vulnerable to watch others, it would me.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly not only is surveillance odd behavior, but it is a statement about your value in the world, your submission to others. To me, and for many, it is a dog rolling over in playful surrender when it is approached by a more dominate breed.
<span class="break"></span>
Another thing concerning his perception of surveillance is this; Donald Trump is a builder. He is a developer and Trump Towers is his project.  He essentially built it.
<span class="break"></span>
Therefore he knows everybody who comes in and out of the towers. He might not know their names, but he certainly knows their faces. Add that to a fact that he has a much younger, beautiful wife in there, and you can be assured he knows exactly what is going on in Trump Towers. It is in his vested interest to do so. He knows his security guys, and probably gets reports from them daily.
</p>
<p class="h-l">
	H.L. He probably knows their names.
</p>
<p>
<span class="douglas">Douglas:</span> I imagine he does, you are right. They serve the king.
</p>
<p class="h-l">
	H.L. He is essentially the king of that building, it sounds right.
</p>
<p>
<span class="douglas">Douglas:</span> Of course he is, and famous people and wealthy people from all over the world live there. There are Russians, Saudi’s and an international cast of who’s who.
<span class="break"></span>
So when he says he had a feeling or a hunch that he was under surveillance, well that hunch is worth a few billion dollars; and you would be wise to listen to it. I imagine many young property developers would feel very privileged to listen to his advice or ‘hunch’.
</p>
<p class="h-l">
	H.L. You’re right there.
</p>
<p>
<span class="douglas">Douglas:</span> It is just one of the bargains we get when we coax a billionaire into running for our highest office.
</p>
<p class="h-l">
	H.L. Coax? That is funny, you think we did that?
</p>
<p>
<span class="douglas">Douglas:</span> I think coax is appropriate. It is my fear, and I think that is the fear of many that one day he will wake up and say, who needs this? It’s not worth it! Then he will go back to his billions.
</p>
<p class="h-l">
	H.L. I don’t see that happening.
</p>
<p>
<span class="douglas">Douglas:</span> Let’s hope not. But no, he definitely knew he was under surveillance, and with Barack Obama at the helm the shoe fits.
</p>
<p class="h-l">
	H.L. It does.
</p>
<p>
<span class="douglas">Douglas:</span> So the summer of 2016 is a mess, it really is. The election is coming up right around the corner. There is a lot of uneasiness in the Democratic Party, Obama’s cronies had already attempted to get a warrant for Trump Towers in the spring of 2016, but failed.
</p>
<p class="h-l">
	H.L. This was to cover their tracks in the wiretapping?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, the wiretapping that had already been going on. You see they were likely not too upset that their FISA application was denied. They still believed that Hillary would win the election and this would all be a mute point.
<span class="break"></span>
Also even though it is illegal, and it was, I would think it is better to have at least tried to get a warrant, and still wiretap when denied, then not even try at all.
<span class="break"></span>
Because upon Clintons presumed victory you could go and say, “Well we really were under belief that our Democracy was in jeopardy.”
</p>
<p class="h-l">
	H.L. Then get off with a hand slap.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, Obama was leaving office anyways, and Clinton could pardon him if he was to be prosecuted for anything.
</p>
<p class="h-l">
	H.L. But that’s not what happened.
</p>
<p>
<span class="douglas">Douglas:</span> No, not at all. Okay, here is where it gets very interesting. Remember when I told you that after the second debate everyone knew it was over.
</p>
<p class="h-l">
	H.L. Yes. You said it was over because of that great political maneuver by the Trump Team.
</p>
<p>
<span class="douglas">Douglas:</span> Well, obviously I was not the only one to think so, Barack Obama likely agreed. The second debate was October 10. Five days later they got a FISA warrant for wiretapping Trump Tower application approved.
</p>
<p class="h-l">
	H.L. So you are implying Obama and his team knew it was over for Clinton then?
</p>
<p>
<span class="douglas">Douglas:</span> It sure looks that way, time to fold up shop and head home.
</p>
<p class="h-l">
	H.L. It is coming into focus now. If I remember correctly during this time didn’t Hillary Clintons show signs of fraying, weren’t there reports of her saying in October that if Trump wins they were all going to hang?
</p>
<p>
<span class="douglas">Douglas:</span> Exactly she is freaking out. But more significant and this will be important later, is that she says they are all going to have nooses around their neck and something to the effect that she would ‘take everyone down with her’.
</p>
<p class="h-l">
	H.L. Donald Trump definitely had the goods on her.
</p>
<p>
<span class="douglas">Douglas:</span> Sure he did. Look, people really liked Donald Trump and they wanted to help him. If they know something is going on and Clinton or Obama were behind it, they wanted to bring it to his attention. Donald Trump was not going to go looking for that information, as that is not his style. But people were likely bringing him boxes of information on those two crooks. At this point he is the most popular kid in the schoolyard and everybody wants to share their lunch with him.
</p>
<p class="h-l">
	H.L. And in one of those boxes contains The Theorem, <span class="italic">The Legacy Letter</span> and how the Obama Administration and Hillary Clinton were suppressing it.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and it was a big box.
</p>
<p class="h-l">
	H.L. But why didn’t Donald Trump come out with the information; have it leaked by a third party?
</p>
<p>
<span class="douglas">Douglas:</span> Appropriate question sure. I have a simple answer, because they would have thrown him in Bellevue!
</p>
<p class="h-l">
	H.L. I see, yeah how would he explain all of this?
</p>
<p>
<span class="douglas">Douglas:</span> There is simply no way for anyone to explain this but me, as I was in the middle of it. And even now when I listen to the tapes of these interviews, look at my responses it all sounds so ridiculously impossible. This was Obama’s and Clinton’s greatest shield; the narrative is impossible to explain, outlandish to suggest and absurd to even imagine.
<span class="break"></span>
The Theorem itself, the probability of one model being able to unlock all the doors of every imaginable behavior and disorder alone would tie the tongue of the most skilled orator.
</p>
<p class="h-l">
	H.L. Then the government’s attempts to suppress, all the steps they went through, it’s as you say, so surreal.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it is, imagine trying to explain this on prime time news. It is simply would have been too much.
</p>
<p class="h-l">
	H.L. So Donald Trump has the evidence against Hillary Clinton, but he can do nothing with it.
</p>
<p>
<span class="douglas">Douglas:</span> That’s right. He is not going to risk his political career to seem like some kind of conspiracy kook.
</p>
<p class="h-l">
	H.L. It is so true; that’s our job.
</p>
<p>
<span class="douglas">Douglas:</span> Yeah, really. No in all seriousness there was another reason too. It was perhaps more damning than the first.
</p>
<p class="h-l">
	H.L. I imagine so.
</p>
<p>
<span class="douglas">Douglas:</span> Well there is, actually a lot more to it. So you were right.
<span class="break"></span>
Donald Trump had no idea where my loyalties were at the time. Remember, they are feeding him false information though the spies on his campaign, both Obama and Clintons spies are doing this. All in attempt to tarnish this jewel of a find Trump has in regards to the cover-up. They are feeding him the belief that I work for the Democrats.
<span class="break"></span>
So imagine if Donald Trump’s team were to attempt the impossible and explain the cover-up from the outside. Then I turn around and say, what are you talking about?
</p>
<p class="h-l">
	H.L. I see, he didn’t know where your loyalties were sitting. This is really starting to make sense.
</p>
<p>
<span class="douglas">Douglas:</span> And then, this is where my girlfriend enters the picture.
</p>
<p class="h-l">
	H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> So I should disclose then that after I finished <span class="italic">The Legacy Letter</span> and right before we left Tennessee in December of 2015, she was hired by an international surveillance and intelligence company. Now she had no experience in this field and the job conveniently fell into her lap.
</p>
<p class="h-l">
	H.L. How convenient. The plot thickens.
</p>
<p>
<span class="douglas">Douglas:</span> Yes and no. I knew right away who the company was and what they were up to. I figured they were a subcontractor for the CIA, NSA or whatever agency that the operation by Obama was being run through.
</p>
<p class="h-l">
	H.L. And it didn’t bother you?
</p>
<p>
<span class="douglas">Douglas:</span> Not really. While she didn’t like being used by them like that, and I didn’t appreciate the fact that the government was now in my bedroom, we needed the money. They paid her very well, and she was able to work from home and spend time with her daughter.
</p>
<p class="h-l">
	H.L. Sure, why have her leave the home, after all they were watching you.
</p>
<p>
<span class="douglas">Douglas:</span> That’s funny, so true.
</p>
<p class="h-l">
	H.L. But to the outside, to the Trump Team, this would have given them even further reservations about contacting you.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, of course.
</p>
<p class="h-l">
	H.L. But your loyalties were with Trump?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but not just mine; hers were as well. And anyone who was listening to our conversations at the time would have known that, both Obama and Clinton.
</p>
<p class="h-l">
	H.L.  That’s how you knew Donald Trump wasn’t listening to you, or had any surveillance.
</p>
<p>
<span class="douglas">Douglas:</span> That’s how I know he had no surveillance on me or he would have contacted me right away; at that point I couldn’t stand Obama and Clinton for what they had done to me. I am telling you, Donald Trump is honest. I know this for many reasons first hand.  He just wasn’t going to do something to mess his chances up at the presidency.
</p>
<p class="h-l">
	H.L. As it turns out he didn’t need to expose her anyways. They lost all on their own.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, how are you going to run a successful campaign when you spend half your day locked up in this cover-up?
</p>
<p class="h-l">
	H.L. That is very true.
</p>
<p>
<span class="douglas">Douglas:</span> Still, just because the election is over, all the dynamics of the cover-up are still in play. Barack Obama has got to do something to deal with President-elect Trump. This isn’t just going to go away.
</p>
<p class="h-l">
	H.L. No it’s not. It’s not at all.
</p>
<p>
<span class="douglas">Douglas:</span> The Democrats just never thought they could lose. They were arrogant, sloppy and out of touch with the distant rumblings. But it was more than that, and this brings up something much deeper about Obama’s relationship with Hillary Clinton near the election of 2016.
</p>
<p class="h-l">
	H.L. Go on.
</p>
<p>
<span class="douglas">Douglas:</span> Well, in many ways at this time Barack Obama wasn’t really thinking about what was ahead of him, about the election, in one way or the other. He was living in the moment.
<span class="break"></span>
He certainly wasn’t thinking about Hillary Clintons’ election chances; all of Obama’s actions are male dominated at this point: Donald Trump, me, his father, suppressing The Theorem.
<span class="break"></span>
It was like the ultimate video game for him, to suppress the book and the surveillance. In many ways he is living in fantasyland, in many ways we as a country enabled him to live insulated in The White House.
<span class="break"></span>
I doubt he was thinking ahead to consequences of any relevance with Hillary Clinton. He was surrounded by females and he didn’t like the fact the she was going to be president in many ways, as she would likely pull him back into her corruption.
</p>
<p class="h-l">
	H. L. So do you think Barack Obama, who had plenty of female energy, a good mother, this is why he didn’t notice Hillary Clinton.
</p>
<p>
<span class="douglas">Douglas:</span> I think he has a lot of charisma with females. But no, I don’t think there was any abuse there. His issues were with males, many, at this time at least. Later this will likely change, but now it is all males that are his focus.
<span class="break"></span>
At the same time, he had to almost hate Hillary Clinton at this point; I imagine she caused a stress response when he was around her. She had really stolen all of his two terms of the presidency, and distorted his legacy, either directly or indirectly.
</p>
<p class="h-l">
	H.L. I see, and now on top of that she is going to be president.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, it had to seem unfair.
</p>
<p class="h-l">
	H.L. That’s why he didn’t really help her. That makes sense to me.
</p>
<p>
<span class="douglas">Douglas:</span> Sure and it will be his own undoing, but he can’t get past the bitterness of what she has done to him.
</p>
<p class="h-l">
	H.L. Who could?
</p>
<p>
<span class="douglas">Douglas:</span> No one.
<span class="break"></span>
So Obama is doing nothing for her, nothing. No wiretapping, no surveillance, barely any campaign appearances.
</p>
<p class="h-l">
	H.L. And when he does campaign appearances he is attacking Donald Trump. This makes so much sense now, when you say everything on his agenda was male dominated.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, and that is not helping the party at all. For America to see Barack Obama that way, almost vicious against Trump, it was not what the Democratic Party needed.
</p>
<p class="h-l">
	H.L. But he didn’t care.
</p>
<p>
<span class="douglas">Douglas:</span> He didn’t care. He could have cared less. But when he did go out and campaign he was going to quit giving to Hillary; he was going to make sure he got something out of it for him, which was of course dialogue related to his male dominated needs or frustrations.
<span class="break"></span>
Again, he was done with females at that point. He wanted to be free of females essentially, to get away. He was surrounded by women.
<span class="break"></span>
So it is important to see that there is no way he is going to put surveillance on Trump Towers for anything related to a female. It’s just not going to happen; he will not risk it all for that.
</p>
<p class="h-l">
	H.L. That’s how you knew you were a part of it?
</p>
<p>
<span class="douglas">Douglas:</span> Of course, Donald Trump by himself was not his target; his target was his secretive and private legacy of squashing The Theorem for the Democratic Party, and anything that threatened that threatened him. So that is why he put the surveillance on Trump Towers. That is when he ratcheted up my surveillance.
<span class="break"></span>
The thing is he wanted attention from males; sure he wanted Donald Trump’s attention but…
</p>
<p class="h-l">
	H.L. But he had already received some of it with the birth certificate issue.
</p>
<p>
<span class="douglas">Douglas:</span> That’s it, now you are on it.
<span class="break"></span>
But I still gave Obama no attention.
</p>
<p class="h-l">
	H.L. And now, before the election, you are getting interested and giving attention to Donald Trump. This to make matters worse for Obama.
</p>
<p>
<span class="douglas">Douglas:</span> Of course I am. Someone from a presidential candidate’s team is visiting my website often. I am no hotshot; I put on my work boots like everyone else. I was very honored from this increased attention. One of my billionaires is going to be president! I was so proud. Of course he is not one of ‘my billionaires’, but I called them that at the time, the ones who received <span class="italic">The Legacy Letter</span>.
</p>
<p class="h-l">
	H.L. No, I understand you were excited for him.
</p>
<p>
<span class="douglas">Douglas:</span> You know I can look back, and I may seem callous and matter of fact to all these events now, four years later as I have been through so much. But at the time it was all a very big deal to me. Especially as I was only then piecing together fully what had happened to me during the Obama Administration.
</p>
<p class="h-l">
	H.L. Of course, it would have been a big deal for anyone.
</p>
<p>
<span class="douglas">Douglas:</span> It’s essential to point out; it was a purely psychological interplay that was occurring. If it wasn’t for the wiretapping, which was related to The Theorem, personally I don’t think he would have minded if Donald Trump became president.
</p>
<p class="h-l">
	H.L. Because Donald Trump gave him attention.
</p>
<p>
<span class="douglas">Douglas:</span> Sure which leads me to believe that there was mild abuse to Barack Obama by a male father, stepfather someone in the picture. Perhaps that is even why his mother wanted him away from the stepfather. Who knows? It was not a good environment, of this I am certain.
</p>
<p class="h-l">
	H.L. Because he wanted the attention even if it was negative.
</p>
<p>
<span class="douglas">Douglas:</span> Sure. Or at least he would take it, but not to the degree of the Clintons, not at all. He is way healthier, fifty times healthier than those two.
</p>
<p class="h-l">
	H.L. Well his male dominated fascination didn’t help them, as the Democratic Party won.
</p>
<p>
<span class="douglas">Douglas:</span> And if there would have been a male Democratic Presidential Candidate, likely Barack Obama would have gone all in for him, because that would have been inline where his interests were focused at the time.
</p>
<p class="h-l">
	H.L. This makes so much sense. History really does come down to the little things, doesn’t it?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it does.
</p>
<p class="h-l">
	H.L. So this is the prelude, the headwaters as you say to the Impeachment hearings, to Spygate and the Russia probe?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, this is the origin of it all. Barack Obama had to build a narrative to explain his actions. So it starts out as Donald Trump or his team finding out about the years of suppression of The Theorem and <span class="italic">The Legacy Letter</span>, the targeting of my potential donors and investors. Barack Obama becomes nervous about this, and starts wiretapping Trump Towers, with or without a FISA warrant.
<span class="break"></span>
Barack Obama is concerned about my lack of activity in the spring and summer of 2016 and figures I may be planning to secretly contact Donald Trump’s team and tell them what I know. Obama’s suspicions were accelerated by the fact that he was traveling internationally extensively during the spring of 2016. In response to these two developments he intensifies surveillance of my Missouri residence. He doesn’t hide this fact, as he wants me to know I am being watched and this is an effort to prevent me from contacting Donald Trump’s team independently.
</p>
<p class="h-l">
	H.L. It so much makes sense. Barack Obama assumed you know more than you did, because he had been watching you for so long, he just assumed you were piecing it altogether. I think that would be a normal reaction.
</p>
<p>
<span class="douglas">Douglas:</span> Sure I was piecing it together, just not as fast as he thought I was. And you add the fatigue of 8 years of the presidency to that. Obama couldn’t take any chances.
<span class="break"></span>
So in response to Donald Trump's team finding out about the cover-up, Barack Obama plants a spy within the Trump campaign. They provide a false narrative that I am working secretly for the Democratic Party, working secretly to test party loyalty for Obama and maybe even Hillary Clinton. This belief is furthered by the fact that my live-in girlfriend at the time is working for a subcontractor for an intelligence agency that indirectly reports to Barack Obama.
</p>
<p class="h-l">
	H.L. Obama suffocated all the information release. He had you surrounded like a fortress.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, you are right. You cannot overemphasize the brilliance of Barack Obama here, even in this somewhat panicked state, he is cool-headed and collected and executes all of these steps perfectly.
<span class="break"></span>
It is true, I am surrounded. I have some damning information, as I am the one they have been suppressing. I was the hub of all the potential investors who had <span class="italic">The Legacy Letter</span>. I was the common denominator with all the harassments and the prosecutions. I had an unobstructed view of what Barack Obama had been doing to them.
<span class="break"></span>
Therefore I was the one who could tie all the names and the dates together. I was the one who could build the comprehensible narrative to this cover-up. If I were to have shared that with candidate Trump, not only would Hillary Clinton be in trouble, but Barack Obama would have been in even bigger trouble.
<span class="break"></span>
So they smothered me in a fortress like you say; my girlfriend was on their payroll, my house was surrounded by agents and not a word I spoke went unrecorded.
</p>
<p class="h-l">
	H.L. Obama knows you have some damning information on him, because you said you were complaining to your girlfriend about it, like you said.
</p>
<p>
<span class="douglas">Douglas:</span> All the time. All the time I was complaining. You know I am not used to failing. It all made no sense to me, with the interest in <span class="italic">The Legacy Letter</span> the way it was. Sure in Tennessee I blamed myself, and maybe continued the self-blame all the way through 2015 in Missouri. But by 2016, it was obvious what they were doing to me. I was really frustrated.
<span class="break"></span>
Now when it got close to the election, I went one step further and publicly told Obama essentially that I knew what was going on.
</p>
<p class="h-l">
	H.L. What?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, so by the end of October 2016, as I said I was really fuming. I published on The Theorem’s website a letter to my readers. There were actually two letters; both similar in content. So in the first letter I stated to my readers, to the men who had been prosecuted and lost so much for supporting The Theorem that I saw them as heroes and that a change was coming. Soon this would all be essentially uncovered.
<span class="break"></span>
Now in the first letter, I even went as far as to state resignations in the Obama Administration, indirectly referencing Eric Holder and others. But I got too nervous and only left that letter up for a day. So in the second letter, I left out specifically the Obama Administration by name, and watered the letter down for a bit. But again I only left that one up for a few days as well.
</p>
<p class="h-l">
	H.L. So you essentially eliminated any doubt that you knew what they were doing by that time. Why did you take it down, were you scared?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, of course. Remember the surveillance is right outside of our door. It would have been easy for one of them to sneak in the middle of night, and eliminate us all. And of course the second night, we heard someone clumsily trying to get into the house, which I took as a warning. I figured if they wanted us dead, we would have never heard a thing.
<span class="break"></span>
If it was just me in there all by myself, I can all but guarantee you I would have left it up. But a child was in there with us; her daughter, so that was out of the question.
</p>
<p class="h-l">
	H.L. So Obama’s intimidation tactics worked.
</p>
<p>
<span class="douglas">Douglas:</span> Sure they did, but there is another reason I took it down, and we will get into that later. This whole incident will be important after the election, as it will partially dictate Obama’s actions, unbeknownst to me at the time.
</p>
<p class="h-l">
	H.L. Okay, back to your summation.
</p>
<p>
<span class="douglas">Douglas:</span> Right, so Donald Trump has the goods on Hillary Clinton and Barack Obama but can do nothing with them. He can’t explain the narrative of The Theorem, and the suppression of <span class="italic">The Legacy Letter</span>. He can’t trust me, so all he can do is to visit my website and wait for me to spill the cover-up.
<span class="break"></span>
Now for Barack Obama, he has to mine all the information out of the Trump Campaign that he can. He has surveillance, spies and wiretapping all over Donald Trump.
<span class="break"></span>
Hillary Clinton and Barack Obama’s relationship is beyond frayed at this point. She doesn’t want to be the one left out of the loop. So she wiretaps my residence and places spies within the Trump Campaign; though she likely had them there already.
<span class="break"></span>
Of course you can’t fool the master spy Barack Obama, so he finds out Hillary is wiretapping my residence and this makes him more uncomfortable. Her surveillance people are sloppy and could get caught, and they may have the morning after the election. Meanwhile Hillary Clinton is locked out of Barack Obama’s inner sanctum and therefore dispatches Bill Clinton to Attorney General Loretta Lynch to find out what she knows in regards to Obama’s thinking on the matter, and about Hillary’s fate in general. Of course she likely knows little, but no matter, he tried; essentially stalking Lynch’s plane at the airport in Phoenix.
<span class="break"></span>
It’s a mess. With each action by one party involved, then becomes responsible for a counteraction by the other; hence, the makings of a multidimensional scandal.
</p>
<p class="h-l">
	H.L. Thanks for that.
</p>
<p>
<span class="douglas">Douglas:</span> Now things are going to move rapidly. So hang on.
</p>
<p class="h-l">
	H.L. Okay, I will.
</p>
<p>
<span class="douglas">Douglas:</span> So we all know that Donald Trump won in November. But when everyone else is watching our new president-elect, I have my eyes firmly fixed on my captor; Barack Obama.
<span class="break"></span>
Once again, everyone is watching the celebrations; everyone is looking one way, I am looking the other, and I am about to witness some of the greatest sleights of hand in American Political History.
<span class="break"></span>
What he will do from here on in, his mental health, his actions will ultimately dictate what happens in the United States well into the Trump Presidency, and the fallout continues even today.
</p>
<p class="h-l">
	H.L. I see. What about you?
</p>
<p>
<span class="douglas">Douglas:</span> Me, well, I will stay in Central Missouri for a few months to let all of this process.
<span class="break"></span>
But as Barack Obama’s mental health further deteriorates, I will be planning to depart for deep in the Ozarks, by myself, to be with the local people: where I can spot those who might come and try and eliminate me from a greater distance and with greater contrast.  I’m not scared, but I am cautious, and certainly I do not want to risk the lives of those around me.
<span class="break"></span>
But I will never stay in one place for too long, as I have a good feeling I know what is in store for me; ultimately I will move to California, work and save up enough to go see my children in Europe for the first time in many years.
<span class="break"></span>
But for now I am staying put, and starting to piece together the events I had just experienced.
</p>
<p class="h-l">
	H.L. Like you said it takes a while to process everything.
</p>
<p>
<span class="douglas">Douglas:</span> Sure it does. But again, more than an observer, I am very focused on what Barack Obama is going to do next. Every single move he makes will interest me. He wanted my attention during his administration, I certainly didn’t give it to him; he has it now however, he definitely has it now.
<span class="break"></span>
While I had never been seriously concerned for my safety before, I had never been a loose end before. So, watching him now; from the day after the election until his exodus to the South Pacific, takes on a new meaning.
<span class="break"></span>
Indeed, little motivates a man more than the personal safety of himself and those around him.
</p>
<p class="h-l">
	H.L. Now I get it, I think you just connected every single dot for me with that last statement.
<span class="break"></span>
You see I always wondered, after first reading your summary how you would know so much about the psyche of Barack Obama, I mean who would care; he is no longer President? But I imagine if you felt your safety could be at risk.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, I know how this works. Operation over, tie up loose ends, move on. Again, it is a very uncomfortable situation. Where I was once carefree, I am now suddenly careful. Where I was once careless, I am suddenly cautious.
<span class="break"></span>
Now with that hyper alert state also evolves a perception, a deep perceptional ability, and this goes way back into our infancy, and into our childhood. And fear has a way to reawaken those abilities.
<span class="break"></span>
You see in my mind over eight years, I had developed a belief system, one that gave me peace and solace regarding this little triangle of Bill Clinton, Hillary Clinton and Barack Obama.
<span class="break"></span>
I always felt that if it were up to her, up to Hillary, I would become victim to some unfortunate accident; after all it would be the easiest way to eliminate the problem.
<span class="break"></span>
I always believed The Theorem was way over Hillary’s head and so were the historical implications of it. While she is smart, she is not that type of smart, as she is blinded by denial and passion. Also she is not the main protagonist in her relationship with success; she is essentially a hitchhiker to fame. She is not the main player, Bill Clinton is. Does that make sense?
</p>
<p class="h-l">
	H.L. Yes, definitely, and the other two?
</p>
<p>
<span class="douglas">Douglas:</span> Well they are the key aspects of the triangle. So if something happened to Bill Clinton, I didn’t care, because then Hillary would morph into something else. And anything except who she is now would be welcomed.
<span class="break"></span>
And it was the same if Hillary Clinton disappeared out of the picture, I could care less about her fate; as I didn’t see any changes in the dynamic in regards to Bill Clinton or Barack Obama if she was gone.
</p>
<p class="h-l">
	H.L. But Barack Obama, it was different?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, he was the key; the moral voice of reason in this triangle, with him out, it could collapse upon me. This was always my concern, or at least a quickly evolving one.
</p>
<p class="h-l">
	H.L. I just realized; you were in this deep and for a long time.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I was, especially since 2014; it was just a fact of my life.
<span class="break"></span>
One thing is for sure. I know and can feel that there are things that have happened, I don’t know about that are even scarier. I can feel that especially when I talk about this. I can almost see one of those three reading this and saying, “You just have no idea how correct that last statement is.” In fact it gives me chills to think about it.
</p>
<p class="h-l">
	H.L. Yeah, me too.
</p>
<p>
<span class="douglas">Douglas:</span> It was so bad after the election that my girlfriend and I would even joke about it. We would say to each other, “You are the loose end, they will eliminate you!” Then the other one would say the same back. This would go on for days.
<span class="break"></span>
True, it wasn’t funny, but we had to do something with the compounding discomfort from the obvious reality we both had to face; there was a regime change and we were loose ends, toys a kid tired of playing with, and we didn’t know if we would be thrown in the toy box or out in the garbage.
</p>
<p class="h-l">
	H.L. So it was that obvious to everyone, circulating through the air like that?
</p>
<p>
<span class="douglas">Douglas:</span> Sure it was there alright, and joking relieved the tension.
</p>
<p class="h-l">
	H.L. Wow. So you say the ‘moral voice’, is that why you think Obama and Bill Clinton kept you alive in contrast to Hillary?
</p>
<p>
<span class="douglas">Douglas:</span> Again, here I am just guessing, right; your own demise, your projected demise, who wants to spend anytime analyzing that? That’s just strange.
<span class="break"></span>
But instinctually I always felt Obama would never tolerate that. But again, I may have had it all backwards. Who knows, but this was the bedrock of my belief regarding those three.
</p>
<p class="h-l">
	H.L. So that is a really sad reality. Now before 2014 did you spend time thinking about this, about your potential elimination at the hands of these three or one of them?
</p>
<p>
<span class="douglas">Douglas:</span> Never, I mean almost never. If I did I knew I was tired and when any of us get tired we have a tendency to become a little bit paranoid.
</p>
<p class="h-l">
	H.L. Correct.
</p>
<p>
<span class="douglas">Douglas:</span> So I would sleep and then not think of it again. In fact, I didn’t even think of it really much from 2014 on; just now at this moment, when the election was over, it all pretty much hit me: Hey, time to wise up!
</p>
<p class="h-l">
	H.L. You probably wouldn’t see it coming anyways so why think about it.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, but also why kill the golden goose? I mean that’s what I was for Barack Obama and Bill Clinton.
</p>
<p class="h-l">
	H.L. What do you mean by that?
</p>
<p>
<span class="douglas">Douglas:</span> Well if you are going to suppress another man’s spirit and his accomplishments you are not going to get much more energy off anyone else than with me.
<span class="break"></span>
I have a large amount of male energy and a brilliant discovery. They are, and were, living off my back by suppressing me. They were harvesting my energy, to prop themselves up.
</p>
<p class="h-l">
	H.L. That’s wild. So just as Bill Clinton lives off of Hillary’s back to offset his lack of female energy, you are saying that he is gaining male energy from living off of your back.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it sounds bizarre when you are saying it, but it is the ‘way of the world’ as you would say it; but not just Bill Clinton, Obama as well. The same or similar rules apply to not having a good mother as not having a good father or one that was not there.
<span class="break"></span>
Now Bill Clinton has a little more male energy than Obama, but not much. If you saw either one of these two walking down the street without knowing who they were or without their entourage; to you as a male, they would be essentially invisible.
<span class="break"></span>
I can tell the minute that I meet another man, right away what type of father he had; within seconds. We all can, and the same with women. It just registers on a subconscious level. I am only verbalizing what we all do unconsciously.
</p>
<p class="h-l">
	H.L. That is so fascinating; I have just never heard anything like this before.
</p>
<p>
<span class="douglas">Douglas:</span> That’s not true. You most definitely have; charisma and confidence. I am just taking you behind the scenes, and showing you what is behind the curtain of those blanket observations.
<span class="break"></span>
Actually John Lennon said it best years ago in the song <span class="italic bold">Come Together</span>: <span class="italic">"He’s got to be good looking because he is so hard to see."</span>
<span class="break"></span>
My interpretation of those words at least, was that someone who is lacking internal energy, who radiates nothing has to compensate for it by being perfect, remarkable or as Lennon said; good looking.
<span class="break"></span>
It is a powerful lyric.
</p>
<p class="h-l">
	H.L. Great song.
</p>
<p>
<span class="douglas">Douglas:</span> It is, you see at one time for a child, to not be noticed by their parents in certain situations could be life-threatening. To be ignored meant you were not going to get fed, not going to get changed or something worse even; maybe it is a signal that your parents are mad and you will now be beat.
<span class="break"></span>
For most of us to be ignored is no big deal; but for others, those who have suffered a bad childhood, each time they are ignored by strangers then those early fears spring up, as they were reinforced within them from their environment in childhood. So they need to be noticed, being ignored or being invisible reminds them subconsciously of that struggle for survival.
</p>
<p class="h-l">
	H.L. So then all of that pain is pulled up as well?
</p>
<p>
<span class="douglas">Douglas:</span> Right. So then to avoid that pain; this early struggle for survival, they make sure they are not ignored. They make sure they are noticed. And since they do not possess their own energy to generate or radiate noticeable qualities or charisma, they cheat. They harvest the energy off of another woman or in this case a man, to obtain that threshold or equilibrium organically lacking.
</p>
<p class="h-l">
	H.L. That is very true, it is fascinating. So they have been indulging in male energy that is not theirs to indulge in, by suppressing your book and therefore indirectly suppressing you. This gives them more confidence with men?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, though I would say they have been directly suppressing me, not indirectly. But yes, now you are getting it. And I am calling them out for it. Of course they are doing it to President Trump now; they found a fresh new victim. And just as I am not going to stand for it, he is not either.
</p>
<p class="h-l">
	H.L. No he’s not. He’s not at all.
</p>
<p>
<span class="douglas">Douglas:</span> But the first step to getting rid of a parasite of sorts, one that attaches to your body, your spirit or energy is to identify who is doing that; to find out what species the parasite is.
</p>
<p class="h-l">
	H.L. And learning more about the behavior of the ‘parasite’ correct?
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, only an arrogant fool doesn’t get to know their enemy. You also must respect them, this is important. From what you can see, I obviously do. It doesn’t mean that I like them.
</p>
<p class="h-l">
	H.L. So these people, these men essentially go around life trying to prop themselves up on the backs of other men; all to gain more confidence and charisma of what is lacking because of their absence of a father?
</p>
<p>
<span class="douglas">Douglas:</span> Yes.
</p>
<p class="h-l">
	H.L. It is just so remarkable. It really makes sense, the motive behind the motive. I want to go and examine all the people I know; men and women and apply what you are saying.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well it takes awhile to learn how to do that. People can be wily, and they hide their weakness and deficits cleverly. So don’t be frustrated if your results are not what you think right away. It takes time.
</p>
<p class="h-l">
	H.L. It is just remarkable that is all.
</p>
<p>
<span class="douglas">Douglas:</span> Sure.
<span class="break"></span>
But here is the thing; this is all based upon me being a victim.
<span class="break"></span>
I don’t mind disclosing this, but there has got to be a balance. Again, this is all very uncomfortable for me. So I’d like to move on. Perhaps another time we can focus on this, but not now.
</p>
<p class="h-l">
	H.L Okay
</p>
<p>
<span class="douglas">Douglas:</span> One final thing: the benefit of having someone taking your energy or suppressing it, is that you get stronger from it. So I have become incredibly strong over the last eight years.
<span class="break"></span>
This is true to a point right?
</p>
<p class="h-l">
	H.L. Yes, to a point. You could theoretically be held under water for too long, and without air or hope as you say, then you become broken.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, they had me on the ropes many times, very close to that.
</p>
<p class="h-l">
	H.L. Yes, I can believe that.
</p>
<p>
<span class="douglas">Douglas:</span> So then after the election, I am going to be in hyper alert state. I am going to see things that other miss.
</p>
<p class="h-l">
	H.L. I can see why now, as the triangle is being broken into pieces.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it is, into pieces.
<span class="break"></span>
It will be better if I give you an example of how this process works, obtaining this hyper alert state. I have a good one as well, in regards to Bill Clinton. It’s appropriate.
</p>
<p class="h-l">
	H.L. Okay, let’s hear it.
</p>
<p>
<span class="douglas">Douglas:</span> Over the last 20 years, as little as I follow political news, I have heard this statement from political analysts.
<span class="break"></span>
They have said something to the affect that no one can ‘work a room’, the way Bill Clinton can, or at least could. He has the charisma and the charm, he knows which hands to shake, who to embrace and who to ignore. Have you heard this about him before?
<span class="break"></span>
This of course was back in his day, back many years ago.
</p>
<p class="h-l">
	H.L. Yes, I have. It’s very well known or even accepted that at the peak of his popularity he was one of the best at it. Maybe even the best ever. It was a large key to his political success.
</p>
<p>
<span class="douglas">Douglas:</span> Okay, so knowing what you know now about how his childhood went can you begin to piece together how he would end up the ‘king of the room’ in political arenas?
</p>
<p class="h-l">
	H.L. In a way, but I am sure you are going to tell me.
</p>
<p>
<span class="douglas">Douglas:</span> Well just think about it a minute. Take a room, a political room and strip it of all its elegance, its eminence. Now take that room back forty, fifty or sixty years and you are in Hope Springs, Arkansas. Now remember little Bill Clinton is on edge. Let’s say he is 10 years old.
<span class="break"></span>
He is the ultimate diplomat. Whatever he does, he is walking in a minefield. The cost of failure, of a misstep is high. He twists the wrong way, fails to conceal his weakness and that abusive bastard stepfather lets him have it. Smack!
With his mother it is the same way; he is dealing with drunks and abusers, and while he needs their company and will compromise himself to obtain it, as all children do, he must be on high alert for the miniscule changes; the micro-movements that are occurring, this enhanced sense he has developed, the ones he so keenly refined. This ability enables him to successfully obtain his goals; food, nourishment and the paper thin joy he can cultivate out of a miserable situation.
</p>
<p class="h-l">
	H.L. I see, so he has to walk a horror-filled gauntlet every time he is around this abusive parents or stepparents.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but you have to realize that these micro-movements, these almost vapor like subtleties of energy free-floating around the room would be invisible to you or me.
<span class="break"></span>
Why you ask? Well in my case I didn’t grow up in a household like his.
<span class="break"></span>
Though I have been in situations like that around distant family members, and friends. Of course I could just leave. But he couldn’t. There was nowhere to run to. Young Bill Clinton was stuck in that horrific scene, the gauntlet as you say.
</p>
<p class="h-l">
	H.L. So later in life, from this enhanced perception he develops a unique ability to work any room in the political arena, because he notices things others do not.
</p>
<p>
<span class="douglas">Douglas:</span> Of course he does. The pain and the trauma morphs and is refined into talent.
<span class="break"></span>
The purpose of the story is only to demonstrate there is no substitute for survival as a motivator to train and ultimately enhance one’s perceptions.
<span class="break"></span>
You notice everything. Information others discard or misinterpret you identify correctly. That is why he was so good at it. It is some type of sick and twisted Darwinian survival of the fittest for abused children: the perceptive ones survive, the unobservant ones die.
</p>
<p class="h-l">
	H.L. That is sick.
</p>
<p>
<span class="douglas">Douglas:</span> It is; it is very much so. Unfortunately it happens all the time.
<span class="break"></span>
So I bring this up because for a while I am going to ask you to trust me in regards to that model we just experienced.
<span class="break"></span>
I am going to be the child in that room. I am going to report to you those micro-movements. I am going to utilize a diluted version of this enhanced perception and share with you things only someone who has been in that situation can. We are back in that room now. Like a child with an abusive parent, I have been watching my captor for eight years.
<span class="break"></span>
I know every movement of my jailer because I am motivated to do so, as my very survival is at stake.
<span class="break"></span>
Understanding what I just said is the only way any of this is going to make any sense to you at all.
</p>
<p class="h-l">
	H.L. Sure, I get it.
</p>
<p>
<span class="douglas">Douglas:</span> Because I am going to share with you things, which will essentially deny belief. The statements you have read, as you have said are almost unimaginable and defy logic. But here in this room; this room of horrors, logic as you once knew it does not apply.
</p>
<p class="h-l">
	H.L. I see, so at this stage you are really more than an observer. You are a prisoner, concerned about whether you will be eliminated, or pardoned. Do I have that right?
</p>
<p>
<span class="douglas">Douglas:</span> Mostly yes. It is close enough. I am vested into watching every movement my captor made and those around him once Obama left office. Now with that, I developed a motivated perception, an enhanced observational power.
<span class="break"></span>
I could essentially see what others had missed, or at the very least see things that were kept concealed from the public.
</p>
<p class="h-l">
	H.L. Yes, now I see. It’s not all negative. Some of the byproduct of this is what you are going to share, to explain.
</p>
<p>
<span class="douglas">Douglas:</span> That’s it exactly. While the reason I know this is not a healthy one; as fear of your life never is, I can confidently convey to you what I noticed and observed during that time period.
<span class="break"></span>
So while I was an outsider, I was still locked inside. The bars may have disappeared, but the indefinite sentence remained.
</p>
<p class="h-l">
	H.L. That is just fascinating. In some ways it exceeds this medium. I give that as a compliment.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and thank you.
<span class="break"></span>
So with that in mind realize that what I say is also going to upset a large number of people. What we are dealing with here is the disintegration of a human being, but not just any human being; the former President of the United States. Not just any former president, but the first African-American President of the United States.
<span class="break"></span>
Some will say that I am attacking him because he is African-American and I am Caucasian, I understand. Some will also say that he suppressed The Theorem because he is African-American and I am Caucasian, I understand. However, I believe in my heart neither of these to be true. So I am aware of how this will likely be received or at least perceived. To the best of my ability and experience, I understand the implications.
<span class="break"></span>
But keep in mind, behind the façade, and the props, is a man. It is a man, I think we all can agree is worth saving. It is a man who made some very serious errors in judgment. Still, we all make very serious errors in judgment.
</p>
<p class="h-l">
	H.L. Of course we do.
</p>
<p>
<span class="douglas">Douglas:</span> Nobody wants to talk about this. But his mental health is being used as a human shield by some very unsavory characters, some people who have no idea what the implications of their actions are going to be in regards to the fate of this great Nation. All they care about is concealing their pain. All they care about is concealing their embarrassment of being exposed as pretending to be something they are not. So to untangle this nest of deception we have to first untangle one of its key players: Barack Obama.
</p>
<p class="h-l">
	H.L. That’s so true. A human shield, this is exactly what the Clintons’ see Obama as. It’s sad.
<span class="break"></span>
As far as the rest goes, I wouldn’t worry too much about it. Say what you have to say; explain what you witnessed. I think your words so far radiate a compassion for Obama that simply are not present in your examination of the Clintons.
<span class="break"></span>
You know he is a victim, I do, and probably soon the entire country will. This isn’t to justify his actions, but like you said no one is perfect. Only God is perfect, we are all fallible.
</p>
<p>
<span class="douglas">Douglas:</span> Thank you, very strong words. Really amazing!
Yet there is something else.
<span class="break"></span>
Certainly, no one is going to like what I tell you next, for other reasons as well.
<span class="break"></span>
People will say it is irresponsible; none of my business and that could possibly hurt others. That’s okay; I understand their perception, their perspective. But they should understand mine as well. If you know something about behaviors and disorders then you should share it. Obviously I do; especially suicide, anxiety disorders and depression as they are cornerstones to The Theorem model, to the discovery itself.
</p>
<p class="h-l">
	H.L. I think that is well established. I agree, you need to share it.
<span class="break"></span>
So when do you think this disintegration really started?
</p>
<p>
<span class="douglas">Douglas:</span> I think the first big crack was when Eric Holder left, but we have covered that. I think after the election things started to really spin out of control for him, over the Christmas holiday; going back to Hawaii, even for that last vacation as president may have been a mistake.
</p>
<p class="h-l">
	H.L. Because that is where the trauma started?
</p>
<p>
<span class="douglas">Douglas:</span> That is where a good amount of it took place. You know at this point Barack Obama needs some serious professional mental health counseling, not friends and nostalgic places to spark up good memories and bad. It‘s just too destabilizing to revisit those places where the trauma occurred.
</p>
<p class="h-l">
	H.L. Do you think those around him saw it?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but what are they going to do? He is still the president in December of 2016; there is more than him to think about at that point.  That’s how they would have seen it.
</p>
<p class="h-l">
	H.L. So they go to Hawaii.
</p>
<p>
<span class="douglas">Douglas:</span> They go to Hawaii, and then there is the inauguration back in D.C. in January. Here he has to entertain a man who once questioned his legitimacy in Donald Trump; a man larger than him in physical size and aura and he must concede his party’s dominance.
</p>
<p class="h-l">
	H.L. Those are all big variables, large obstacles. Even in the most supreme state of mental health.
</p>
<p>
<span class="douglas">Douglas:</span> That is right. Even those with a supreme control of their mental health would not be able to maintain that state after eight years of the presidency. Here every crack will be magnified as you are beyond exhaustion; things that will not bother you after a few months of rest are relentless in their intensity now. This cannot be over emphasized.
</p>
<p class="h-l">
	H.L. That is so true, it is a very fragile state; one that gets little attention.
</p>
<p>
<span class="douglas">Douglas:</span> Then he is going to do something very telling. He is going to run.
</p>
<p class="h-l">
	H.L. What do you mean?
</p>
<p>
<span class="douglas">Douglas:</span>  Well, I need to backtrack for a quick story to explain why running here is telling.
</p>
<p class="h-l">
	H.L. Sure, let’s hear it. This is really insightful Douglas; it is very good.
</p>
<p>
<span class="douglas">Douglas:</span> When I was very young, about 11 or 12 years old, I was not a very good kid. Like many kids I was into drugs, though my pain was more severe so I had started earlier and used heavier than most. While I spent my very early years in Las Vegas, we eventually moved to Southern California. By the time I was 12, I was so wrapped up in drugs and hanging around delinquents that my father fretted for my fate. In response he moved us up the coast about 200 miles. I missed my friends, as delinquent and devious as they were, they were still my friends.
<span class="break"></span>
So on the weekends I would go to Southern California and visit them. On one of these visits, the final visit, I was elected by our little gang of thugs to steal a chainsaw; a big concrete chainsaw we noticed in a neighbors open garage. The reasoning was that by the time the cops figured out who did it, I would be safely up the coast. Well I stole the saw, we sold it for drugs and that was that. Then the police came looking for us.
</p>
<p class="h-l">
	H.L. That’s not good.
</p>
<p>
<span class="douglas">Douglas:</span> Now my friends were a rare breed. Even the 10-year-old who hung out with us had been kicked out of school, and he was so bad that the truancy officers would just wave at him when they would go by; this, even during school hours. These were great friends, but to everyone else they were hardcore juvenile criminals.
</p>
<p class="h-l">
	H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> So when the police pulled up, two cars, I ran. I was the only one to run. I was the only one to get arrested. You see my friends knew better, they were smarter, they were experienced. All of us were in on the crime, we each had played our part, and all were guilty in one way or another. But I was the only one to run. I imagine then, by default, I was the least experienced. I had the best chance for recovery; I was green to the process of dealing with the police.
<span class="break"></span>
There was still hope for me.
</p>
<p class="h-l">
	H.L. Sure, you said your parents moved you; at least someone cared about you.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, but my friends weren’t so lucky.
<span class="break"></span>
Now at Donald Trump Rallies the crowds are screaming, “Lock her up!”  This in regards to Hillary Clinton’s corruption, so is Hillary going to flee?
</p>
<p class="h-l">
	H.L. No; she is an experienced criminal, a hardened criminal, like your friends. She has been down that road before.
</p>
<p>
<span class="douglas">Douglas:</span> Do you see where I am going here?
</p>
<p class="h-l">
	H.L. Yes.
</p>
<p>
<span class="douglas">Douglas:</span>  Do you really? This was a big deal to Barack Obama. This was a huge deal. His conscience was ripping out from his chest. He was showing the signs. His psyche could not contain the trauma, and it started to hemorrhage.
<span class="break"></span>
What little innocence of nature he had in him was innocence nonetheless, and it rebelled against the assimilation of these crimes. He could not merge them into his character. So once you are aware of that fact, it is just a matter of tracing the dots of his actions, and they were serious actions with potentially fatal consequences.
</p>
<p class="h-l">
	H.L. Yes, the optics weren’t very good for an outgoing liberal president, a supposed champion of the ‘little guy’, to hang out on an island with a billionaire; Richard Branson founder of the Virgin Group.
</p>
<p>
<span class="douglas">Douglas:</span> Right? Of course to everyone else it made no sense. I should clarify that. It made no sense to everyone else, but to those who received <span class="italic">The Legacy Letter</span> it made perfect sense. I just said to myself, well there goes another potential investor.
</p>
<p class="h-l">
	H.L. I see. True, once you read <span class="italic">The Legacy Letter</span> you do figure this would be something Richard Branson would be interested in.
</p>
<p>
<span class="douglas">Douglas:</span> Of course Richard Branson was sent a copy of <span class="italic">The Legacy Letter</span>. From what I could tell he was very interested in it, and for a long time. So, like The Presidential Awards we will go into tomorrow, his connection to Branson made complete sense.
<span class="break"></span>
After all Branson wasn’t an American citizen so there would have been little punishment Barack Obama could subject him to. So he had to entice him with agreeing to visit to his island. This visit was likely promised years before. And when he got out of office, he made good on his promise.
</p>
<p class="h-l">
	H.L. But that alone was not why he picked Richard Branson’s Island, as you said earlier.
</p>
<p>
<span class="douglas">Douglas:</span> No it’s not; actually not at all.
<span class="break"></span>
He in fact will be visiting Branson’s Nekar Island for another reason altogether. A reason that nothing to do with <span class="italic">The Legacy Letter</span>, nothing to do directly with me, and nothing to do with promises made a few years before. As you will see his Barack Obama’s interest in this island and this man, at this point is for a much more sinister intent altogether.
</p>
<p class="h-l">
	H.L. So let’s just clarify where we are here. The inauguration is over. Barack Obama is about to leave Washington D.C as a private citizen for the first time in eight years. He takes his family and heads to the Palm Springs Area. In three days he will depart, with all of the family to the Caribbean to Richard Branson’s Necker Island for 10 days. Correct?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and thank you for that, we start talking and I forget to give reference to what we are talking about. I forget this is an interview sometimes. So it is the weekend of January, 20, 2017.
</p>
<p class="h-l">
	H.L. It still seemed like an unusual choice of a trip. Obama said he was going to give his wife a ‘special trip’ when he got out of office.
<span class="break"></span>
He could have taken her anywhere in the world, I don’t see how a one hour flight out of Miami is considered special. “Here, this is what you get for standing behind me for 20 plus years honey; a Pirates of the Caribbean ride.”
</p>
<p>
<span class="douglas">Douglas:</span> Pirates of the Caribbean, so true.
</p>
<p class="h-l">
	H.L. It just didn't make any sense at all.
</p>
<p>
<span class="douglas">Douglas:</span> But let’s look at this in another way, really. You just spent 8 years building your house, now you’re going to take a vacation from it. Why? Live in your house.
<span class="break"></span>
I checked online, I can’t be sure, but I don’t believe any president has ever left the country that quickly for an international vacation after leaving office. I just could find no evidence of it. Oh they all will travel, but not right away.
</p>
<p class="h-l">
	H.L. You would think they would be exhausted.
</p>
<p>
<span class="douglas">Douglas:</span> That is such a good point. Yes, you are so right on that.
<span class="break"></span>
I remember when I had a small business that I owned for just a few years, back when I was a young man. It was extremely stressful. Just providing jobs for people was stressful enough, and for the ten men and women who worked for me, I had to make sure I had enough money every week for payroll; I had to make sure they had food on the table for their families. I took my responsibility seriously. So the minute I go out from under that business, from under that stress, it was a huge relief. I went straight into my bedroom and fell into exhaustion, and my body shook for days. It was responding to the massive release of stress. I was 25 years old.
<span class="break"></span>
Barrack Obama is not in charge of some rinky-dink small business. No, he was the President of The United States of America. He wasn’t responsible for 10 people, but instead 320 million! He had to make sure they all were taken care. He had perhaps one of the top five most stressful jobs in the world. The stress ravages and distorts you, and rarely do you leave office even remotely resembling the appearance of the man who entered it. He served two full terms, eight full years. Barack Obama was in his 50’s.
<span class="break"></span>
It is a massive let down. He had literally the entire country on his back, then all of a sudden it is gone; it is a deflation of your defenses, of your hormones.
<span class="break"></span>
You lie to your body for months and years, promising it tomorrow the stress will be gone. You promise yourself you can sleep tomorrow night. All these lies, all these deceptions you trick your body with, your sleep cycle with, come due for collection the minute you get away from that stress. They came due the minute he boarded the plane and left Washington D.C.
<span class="break"></span>
The stress would have hit him. No, there is a reason former presidents do not travel the minute they get out of office. It is almost physically impossible to do so.
</p>
<p class="h-l">
	H.L. I agree, it doesn’t add up.
</p>
<p>
<span class="douglas">Douglas:</span> The primary ways to override your body, to not come down from that type of stressful situation are two things; either drugs or fear. That is it. There are few others: sense of wonderment doesn’t qualify.
</p>
<p class="h-l">
	H.L. Sense of wonderment. That’s so true.
</p>
<p>
<span class="douglas">Douglas:</span> Your body wants to heal, to sleep; a massive weight was lifted off your chest. As men we want to crawl up in a dark room, turn on the television and crash or just vegetate. It is our natural instinct as a mammal to need to hibernate after an event like that. We don’t want to go kite surfing.
</p>
<p class="h-l">
	H.L. That’s so ridiculous. Kite surfing.
</p>
<p>
<span class="douglas">Douglas:</span> The list of improbabilities goes on and on.
<span class="break"></span>
Hawaii would have made sense, and at least it would have been in the USA, the country you just spent eight years building. It is where he had been going on vacation to for years.
</p>
<p class="h-l">
	H.L. Hawaii certainly would have not looked so suspicious, as though he was up to something. I am surprised the press did not jump all over that.
</p>
<p>
<span class="douglas">Douglas:</span> Again, until you are aware that he is aware he committed a crime and fears prosecution, all these events; the ones we will go over, seem strange and disconnected, but once you insert that premise everything makes perfect sense.
</p>
<p class="h-l">
	H.L. I agree. It doesn’t add up otherwise.
<span class="break"></span>
Also if you were in Washington D.C why would you fly all the way out West to California for a day or two; then fly all the way back East again. Seems somewhat deceptive, like you said sleight of hand; we are going this way, and now that way.
</p>
<p>
<span class="douglas">Douglas:</span> No, they were going to flee. They were preparing to flee, Obama could not anticipate what President Trump would do, how much he knew and what was coming next. Barack Obama was certain the minute Donald Trump entered office, he would release all he knew about the cover-up and concealment of The Theorem, of <span class="italic">The Legacy Letter</span> and of his knowledge of the wiretapping of Trump Tower. Remember, just a few weeks before the election, on The Theorem Website, I all but foreshadowed this would happen. I all but foreshadowed that prosecution was imminent, and that a change was coming.
<span class="break"></span>
You have to understand it’s not the way you would normally see it, the way he saw it.
</p>
<p class="h-l">
	H.L. What do you mean?
</p>
<p>
<span class="douglas">Douglas:</span> Barack Obama just didn’t see one or two people coming at him. Without a father around a boy grows into a man and sees other men larger than they are. We dove into that earlier.
</p>
<p class="h-l">
	H.L. Right.
</p>
<p>
<span class="douglas">Douglas:</span> Barack Obama wasn’t seeing just Donald Trump coming at him, he was seeing double; Fred Trump helping his son with real estate or walking with him down a street in Manhattan.
<span class="break"></span>
He didn’t just see me coming at him, he saw my father helping me in the produce business or writing. He was seeing double.
<span class="break"></span>
No, what Barack Obama needed to offset this magnified perception was a father figure with an airline.
</p>
<p class="h-l">
	H.L. He found it in Richard Branson. He must have been driving his wife crazy.
</p>
<p>
<span class="douglas">Douglas:</span> I couldn’t have said it better. This too is going to be a big problem, you’re right.
</p>
<p class="h-l">
	H.L. She is just not going to go along with him, with his panicked state, which you’re describing and desert or subject her children to a life on the run.
</p>
<p>
<span class="douglas">Douglas:</span> No, she’s not. You are so right about that. But Obama has no one he can relate this trauma to. He is trying to contain it within himself, but it’s coming out.
<span class="break"></span>
She is first worried about her children. But she also loves her husband and as a favor, she will give into his paranoia just this one time. He is a convincing speaker, and he has convinced her without a shadow of a doubt that President Trump is going to arrest them.
<span class="break"></span>
Plus he has given her the heights of the American accomplishment. That is worth something, it might get a woman on a plane once, maybe even if she’s a mother, but it won’t be easy.
</p>
<p class="h-l">
	H.L. He is convinced, she is not.
</p>
<p>
<span class="douglas">Douglas:</span> Well but at that time, what he was saying could have been laced with some truths. To get her to go, he had to pull out all the tricks.
<span class="break"></span>
This may be the first time she has learned the depth of the cover-up. To feed this neurotic state, he will reveal all State Secrets to her, all in order to stop the anxiety from consuming him. It is our biological limitation as a man, as a male; a woman can smother our insecurities and heal our perceived inadequacies with the simple nod of her head in agreement. A gentle caress does even more.
</p>
<p class="h-l">
	H.L. That’s very possible. I’m sure she is telling him she didn’t want to know about it either.
</p>
<p>
<span class="douglas">Douglas:</span> Yeah, well then you know how women can be; some will listen and some don’t want to hear about it.
</p>
<p class="h-l">
	H.L. She must have been under incredible stress herself.
</p>
<p>
<span class="douglas">Douglas:</span> I imagine. But this isn’t what he needs right now. He needs the Michelle Obama who he met before they had children. Remember the dynamics change when a woman has a child. They just do.
</p>
<p class="h-l">
	H.L. Yes, and very quickly.
</p>
<p>
<span class="douglas">Douglas:</span> She is a mother, a role model, former First Lady, a lawyer and then a wife. He is in crisis; he needs someone to listen to his whining, and his paranoia while he rewinds all the events to a conclusion; thus enabling him to eventually initiate a plan of action.
<span class="break"></span>
I don’t mean to sound unsympathetic to her needs, but I am first concerned about the one in the deepest crisis.
</p>
<p class="h-l">
	H.L Certainly Michelle Obama had no long terms plans on fleeing with her husband if more information came out about the cover-up as the former president feared.
</p>
<p>
<span class="douglas">Douglas:</span> You’re right; and that is a very good point. You see Necker Island was a departure point. If President Trump released more, disclosing what he likely knew, and the dialogue in Washington was circulating around prosecuting Barack Obama, then some decisions would have to be made. Like you said, his wife is not going to subject her children, her immortality, to a life on the run. So there, in the Caribbean, they would part ways. Michelle Obama would return to the United States to her children, and one of Branson’s private jets would shuttle off Barack Obama to an undisclosed location. This until the Liberal Elite in D.C. could reason and negotiate with the newly minted president who would have likely been furious over the entire ordeal. Then Obama would return to the U.S. and face the music.
<span class="break"></span>
But at least Necker Island was a place where they could spend some quality time before the split, which at this point Barack Obama was convinced would be inevitable.
</p>
<p class="h-l">
	H.L. That makes sense; must have been some plane ride.
</p>
<p>
<span class="douglas">Douglas:</span> An absolute nightmare and it’s just beginning. Because eventually they have to come home and confront the reality of what he was running from in the first place. Immediately, all the equity Barack Obama gained by talking it out with Branson and whoever else was on that island, is going to dilute or even be negated completely; this, the minute they get back to the United States.
</p>
<p class="h-l">
	H.L. So they get home.
</p>
<p>
<span class="douglas">Douglas:</span> They get home, Obama is starting to unwind, and then crash it all starts again! Though this time it is going to be worse; this time he is going to be alone.
<span class="break"></span>
This time he is not planning on coming back.
</p>
<p class="h-l">
	H.L. You’re talking about President Trump’s tweet on March 4th when he accused Barack Obama of wiretapping Trump Towers?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but even before that we have to take a look at the situation he is in. Obama’s access to surveillance for the most part is gone. It has been for some time. So the worst thing for him is the lack of information.
<span class="break"></span>
	Of course coming down off of surveillance is not like coming off of a drug, but for him it is close. The lack of ability to know is going to eat at him, especially when now he is on the other end.
</p>
<p class="h-l">
	H.L. To clarify, you are talking about the time between Trumps Inauguration and Obama’s potential flight from the U.S to Necker Island and the March 4th tweet, so February?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it’s February and he doesn’t have the surveillance tools at his disposal he once had just weeks before. He may have some privately, but he doesn’t want to show his hand to President Trump by using them. Obama is really going to be in the dark at this point.
</p>
<p class="h-l">
	H.L. It’s going to increase his paranoia.
</p>
<p>
<span class="douglas">Douglas:</span> Yes he has been the master and commander. Previously when his insecurities consumed him, for eight years he could look at a monitor; pick up a report, call someone and order more detailed surveillance. It was a crutch he stood on to get through the cover-up. Now it is gone.
</p>
<p class="h-l">
	H.L. I don’t think you can overestimate the importance of that.
</p>
<p>
<span class="douglas">Douglas:</span> Look how people freak out when their TV or computer stops working, or even their smart phone. Now multiply that times twenty or fifty and these are the feelings he is going to experience. He is out of the loop. It’s a communication breakdown for lack of a better term.
</p>
<p class="h-l">
	H.L. It is a problem also very unique to his presidency because the surveillance for him was an obsession.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, now you see it. This was a cornerstone of his presidency. He was essentially addicted to it. This is more than needing to know, it is everything to know.
<span class="break"></span>
Because without the surveillance where is he again?
</p>
<p class="h-l">
	H.L.  Back in his childhood, wanting to know what they are saying; wanting to have some knowledge and therefore some control of his destiny.
</p>
<p>
<span class="douglas">Douglas:</span> That’s it.
<span class="break"></span>
He is back there in his childhood and he is in a very bad condition to face those fears. He is exhausted. And you know what happens when you stop, the pain from those eight years catches up to you.
<span class="break"></span>
Now here is where I get angry. In fact, really pissed off: where the hell was the mental health community? Where the hell was the psychiatrist? I mean at this point we are about to lose a president. This is going to be a national loss, with international implications!
</p>
<p class="h-l">
	H.L. Yeah you can see he was in really bad shape.
</p>
<p>
<span class="douglas">Douglas:</span> And if there were stimulants involved, this is going to magnify the comedown.
<span class="break"></span>
Now I am not saying he was on drugs or anything like that. Do not pin that on me at all. I am just saying that there are things that we as private citizens are not aware of; and when you are responsible for 300 plus million people then there are legal pharmaceutical aids to get you through an otherwise impossible level of stress and an unforgiving schedule.
</p>
<p class="h-l">
	H.L. Especially at the end of 8 long years!
</p>
<p>
<span class="douglas">Douglas:</span> Sure he was exhausted. If they were taken, it was for the well-being of the country and not for recreation. That is what I am attempting to say here.
</p>
<p class="h-l">
	H.L. Could be. Whatever the case he is in trouble at this point.
</p>
<p>
<span class="douglas">Douglas:</span> So it’s February and he is thinking to himself about the Clintons. He realizes something very profound. Even in this deteriorating state he gains clarity when he thinks of them.  He quickly realizes that they are old. They are really old. He also realizes that in 10 or 15 years they will likely not be here anymore, but he will.
<span class="break"></span>
He also knows The Theorem is not going away anytime soon. He knows this better than anyone. He can see the more he pushed it down the more curious people became, he watched those frustrating    dynamics up close for many years.
</p>
<p class="h-l">
	H.L. That’s so true, like a spring.
</p>
<p>
<span class="douglas">Douglas:</span> He also knows this entire cover-up will someday likely unfold. Someone from somewhere is going to snap. There are just too many players, too many loose ends.
<span class="break"></span>
Then there is President Trump. If he gets caught, it will be a nightmare to have Trump in control and telling everyone, “I told you so!”
All of this is going through his head, all of it.
<span class="break"></span>
Then he thinks of the image of the Clintons. Everyone knows of them as corrupt. Yet they function just fine. He doesn’t see himself able to put that hat on. You see now we are into the difference, the filth of the human heart; between neglect and abuse.
<span class="break"></span>
The Clintons were abused as children; Obama for the most part was only neglected and deserted. This is a huge difference on how the character forms. In some ways they subconsciously seek out the punishment, in some ways he does not. It is foreign to him.
</p>
<p class="h-l">
	H.L. That’s really good. I think you are right on the money there.
</p>
<p>
<span class="douglas">Douglas:</span> But he also knows the Clintons bounce. He knows they bounce and turn and somehow float; and he sees the finger pointing at him. He marvels at the various scandals they have survived. Their image is already tarnished, his is not.
<span class="break"></span>
He has way more to lose than them.
</p>
<p class="h-l">
	H.L. It’s a long way to fall. It really is.
</p>
<p>
<span class="douglas">Douglas:</span> But it just never stops. This is Jaws on a big day with huge swells pounding the Maui Coastline; one after another, wave upon relentless wave!
He realizes the terror of living every day, waking up not knowing if this will be his last day of freedom, waiting for that knock on the door, or no knock at all. This fear alone has driven many a criminal to confession. It’s a big deal, a really big issue. Getting away with something is not always getting away with something; the stress on the human body is severe.
<span class="break"></span>
We have all heard of people who lived on the run for years, and one day just confess and surrender. It happens. Only a certain type of person can withhold that sin inside of them, and he is not that kind of person.
<span class="break"></span>
It is pulling him deep under the surf now.
<span class="break"></span>
He can’t really make any long term plans; he doesn’t know what tomorrow holds in store for him. He is already being punished. This was supposed to be the best time of his life, but make no mistake about it, it is a nightmare.
</p>
<p class="h-l">
	H.L. The Clintons claim another victim.
</p>
<p>
<span class="douglas">Douglas:</span> That’s right, but what is going on in his head is far from over, because when he dodges one wave another comes crashing down on him.
<span class="break"></span>
What about his legacy? What about the African-American community that has tirelessly supported him? We could never know what it would be like to represent the symbol of hundreds of year of oppression finally released.
<span class="break"></span>
We cannot understand what it must have felt like to have been the one elevated to those heights. Nor can we understand how he loved them for their praise, how unworthy he must have felt to receive their adoration; how anyone would have felt unworthy of that level of adoration. Our first African-American president; this was a once in a country phenomenon!
</p>
<p class="h-l">
	H.L. So true. We can’t imagine at the same time how it must have been for him to realize the potential fall from that grace.
</p>
<p>
<span class="douglas">Douglas:</span> This was always a huge problem.  I remember years ago, I was a big Nirvana fan. And when Kurt Cobain was alive, I remember every time they would over elevate him and put him on a pedestal, I would just cringe. I really would. It was like Kurt Cobain was not just a brilliant and innovative musician with a unique sound; he is the future of music! Or else it was some other overblown statement.
<span class="break"></span>
I would just want to say into the radio, “No stop! Don’t put that much pressure on him. Nobody can handle that much at that age. Let the man have a few failures first.”
</p>
<p class="h-l">
	H.L. Unfortunately it doesn’t work like that.
</p>
<p>
<span class="douglas">Douglas:</span> No it doesn’t. To put that much weight on a young man’s shoulders, hundreds of years of an oppressed people. He was just too young.
</p>
<p class="h-l">
	H.L. I think he even said it. Something to the effect that he should have waited ten years. I think he said that after the election.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but like a pregnancy; are you ever too young for your immortality?
<span class="break"></span>
I mean he had one chance, and he took it. But on an individual level, at this moment, he was paying a high price.
</p>
<p class="h-l">
	H.L. I can see that. He was really in crisis.
</p>
<p>
<span class="douglas">Douglas:</span> Finally, there is The Theorem. To most readers, those who aren’t familiar with the discovery, this will seem overblown, but in reality it is an underestimation.
<span class="break"></span>
The Theorem is a discovery of such magnitude that it will simply change everything. It is a once in a civilization discovery. To suppress this was a gargantuan task. It was an accomplishment of suppression that will forever be remembered throughout history. It will be one of the largest tag lines connected to his name. It was a multinational effort, with universities involved, and so many players; likely close to a hundred household names from around the globe. There were trillions of dollars involved and we as a society forfeited a great deal of our civil liberties to enable this suppression. It’s all going to come out.
<span class="break"></span>
To be the villainous suppressor unprecedented wasn’t why he went to law school; it wasn’t why he entered politics. But at this moment, this is how he is sure he will be remembered.
<span class="break"></span>
We saw all of this yesterday, but it is circulating through our former presidents’ mind at this stage.
</p>
<p class="h-l">
	H.L. It was a massive operation, a giant cover-up.
</p>
<p>
<span class="douglas">Douglas:</span> Then there is the research, the lives lost because this information was suppressed. The list goes on and on.
<span class="break"></span>
This wasn’t some southern preacher burning Elvis records or Beatles albums; this was a level of suppression and censorship even the most reactionary individual would run from.
</p>
<p class="h-l">
	H.L. Nobody has a right to hold down another man’s work.
</p>
<p>
<span class="douglas">Douglas:</span> No, he saw there would be nowhere to run and nowhere to hide. He was alone. He was around others, yet he was alone. This was as serious as it could become. He was checking out.
<span class="break"></span>
People, he was checking out! Barack Obama was on his way out!
</p>
<p class="h-l">
	H.L. Then came the tweet?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but there is something else first.
<span class="break"></span>
There is one thing we have not talked about and it is a very important emotion in relation to being a motivating factor in regards to Barack Obama’s actions here. It is one that I like to avoid as I suffer from its consequences; though not quite to the level that Barack Obama does at this stage of his life.
<span class="break"></span>
It is one emotion that dominates over all the other reasons, all the problems we have talked about; being concerned that President Donald Trump will prosecute him, letting the African-American community down, concerns in relation to his legacy, being out of the loop with regards to surveillance and the long term implications of suppressing The Theorem. It is an emotion more than any others that is going to be responsible for his attempt on his own life he is about to undertake.
</p>
<p class="h-l">
	H.L. What is it guilt, fear?
</p>
<p>
<span class="douglas">Douglas:</span> Shame. And again, shame itself is so poorly understood, it really is. For me shame is hard to define and convey for two reasons. The first is that it is not necessarily, or at least completely, womb based in origin. Contrast this to guilt, which we may get into tomorrow a little bit.
<span class="break"></span>
Another reason I have a hard time with it is because, again, I suffer from it as well. In my case it is due to my sexual abuse; the multiple instances of rape I experienced as a young child.
<p class="h-l">
H.L. Understandable.
</p>
<p>
<span class="douglas">Douglas:</span> But Barack Obama has it about as bad as I have seen it in anyone. There are many reasons for this, and we can’t go into all of them. But as you would imagine a large progenitor for shame is abandonment by the mother; in this case, by his mother.
</p>
<p class="h-l">
	H.L. I was just going to say that, it makes sense.
</p>
<p>
<span class="douglas">Douglas:</span> In fact, psychologists have done studies and identified feeling extreme shame as a child in 5th grade as a risk factor for a suicide attempt later in life.
</p>
<p class="h-l">
	H.L. I see; this makes a large amount of sense. He feels deserted by his mother, and then he feels inadequate and shameful as a child. Later as you say there is a link between that and suicide attempts.
<span class="break"></span>
So there is actually an indirect link with abandonment as a child and attempted suicide later in life?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, these are very guarded and deep feelings by Barack Obama.
</p>
<p class="h-l">
	H.L. Do you think Hillary Clinton said something to him, and that set him off?
</p>
<p>
<span class="douglas">Douglas:</span> I believe some female did. I think you are right, and all of his focus as you see earlier is on his male issues; he is looking one way…
</p>
<p class="h-l">
	H.L. Then his female issues sneak in and get him from the other way.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I think that is very likely what happened.
<span class="break"></span>
Of course from a male perspective what I posted on The Theorem’s Website, calling him out online about the prosecutions didn’t help. So I was providing the shame from the male vantage point. But like you inferred, it doesn’t seem that would be complete enough; the abandonment by his father. It is a female behind the final trigger to nearly push him over.
</p>
<p class="h-l">
	H.L. I think so. I am putting my money on Hillary.
</p>
<p>
<span class="douglas">Douglas:</span> You know right before the election, in early November of 2016, when I put up that letter to my readers on The Theorem Website, I could feel an emotional shift. It was more of a tilt, then a shift actually. Beyond the obvious security concerns as a motivation for taking that letter off of my site, there was that fretful feeling that it was extremely hurtful to Barack Obama on a personal level. Now why I even cared about this at the time, I couldn’t tell you. But obviously I did.
</p>
<p class="h-l">
	H.L. Like you said you knew your captor.
</p>
<p>
<span class="douglas">Douglas:</span> Evidently
</p>
<p class="h-l">
	H.L. So that is why you took it down?
</p>
<p>
<span class="douglas">Douglas:</span> I think that was part of it, yes. It was almost as though I could feel a man, my captor, on the brink of collapse. Even though I would certainly have had the right, at least partially to push him over, I did not want to be the one to do that. And this was way back in early November, even before the election. So as you would imagine if Barack Obama was radiating that type of frailty then, visualize his condition four months later?
</p>
<p class="h-l">
	H.L. He was in bad shape.
</p>
<p>
<span class="douglas">Douglas:</span> Yes he was.
</p>
<p class="h-l">
	H. L. I always thought shame and guilt were related.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and no. Shame is almost like backwards guilt. Shame stems from when you give someone everything and they reject you, especially at an early age.
<span class="break"></span>
Obama, as most all children do, gave his mother everything. But in his case he was sent away; deemed by circumstance inadequate to command her attention, not entertaining enough to fill up her day. This is how his subconscious would have experienced it.
<span class="break"></span>
Guilt would be closer to the opposite. Someone gave you everything and you reject them; having done something wrong to them or deserted them, this would be a cause to have guilt.
<span class="break"></span>
One of the reasons the relationship is confusing is that behind a person who commits an act that they feel guilty about, often there is a sense of feeling extremely powerless; so therefore they had to use another person to gain back that equilibrium, essentially doing to others what was once done to them.
<span class="break"></span>
So when they are exposed for the act they feel guilty about, the underlying shame stems from the inadequacies and events defining their personality that caused them to commit that act will then rise to the surface; which likely in this case has its origins in rejection as we have seen.
</p>
<p class="h-l">
	H.L. That makes sense. So then with guilt comes the reason behind it, this is what you mean, all the emotions just flood out.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, though shame is much more complex than we are exploring here. In the most severe degree, it is the complete self-judgment of inadequacies and inability to see the cause at the origin. It is not a retail emotion, it is a wholesale one; a total condemnation of the self, global in its consumption. Therefore it completely snuffs out all logic, and retreats into its private world, where it can feed on itself undisturbed.
<span class="break"></span>
I should have explained this earlier today as it would have made more sense, but I avoided it. As I say, I suffer from it as well, though not like I did in my youth.
<span class="break"></span>
When you plug shame into the equation, and the avoidance of it; his wanting to flee in the beginning right after the election makes sense, as embarrassment of his perceived inadequacies were what he feared being exposed to the public.
</p>
<p class="h-l">
	H.L. I agree. But why should he take all the blame on himself though? It was impossible to keep this cover-up from being exposed, to keep it concealed, as you explained yesterday.
</p>
<p>
<span class="douglas">Douglas:</span> I agree, but he is not thinking clearly. He is not thinking clearly and he is not realizing he was given an impossible task. He is not thinking clearly that he has been betrayed. All of this was logical, but his mind is not logical now.
<span class="break"></span>
The fear of shame will fly that plane first to California, then to the Caribbean. Now a few months later shame will fly that plane to Hawaii and then ultimately his prepared last stop in French Polynesia, where he plans on ending his life.
<span class="break"></span>
Avoidance of embarrassment will be the copilot on that flight; he will attempt to flee, to reject others symbolically before he feels that rejection from them.
</p>
<p class="h-l">
	H.L. I was just thinking when you talked about that study and how kids who had an exaggerated sense of shame and then attempt suicide.
</p>
<p>
<span class="douglas">Douglas:</span> Yeah, what about it?
</p>
<p class="h-l">
	H.L. Do you know what grade Obama was in when his mother sent him away from Indonesia to Hawaii?
</p>
<p>
<span class="douglas">Douglas:</span> Not really, I know he was very young though.
</p>
<p class="h-l">
	H.L. 5th grade, the same age as the kids in the study.
</p>
<p>
<span class="douglas">Douglas:</span> Really? I would believe it.
<span class="break"></span>
No, he was definitely planning to commit suicide; there is no doubt in my mind. That is interesting though. I knew it was right after his mother had his sister, and who knows she might have had postpartum depression, as back then they didn’t really understand what that was.
</p>
<p class="h-l">
	H.L. No matter the reason, like you said, it was devastating to Barack Obama.
</p>
<p>
<span class="douglas">Douglas:</span> Of course, Hillary Clinton is only 5 years younger than his mother was as well. It is interesting.
<span class="break"></span>
The Clintons set themselves up as the top of the Democratic Party, as the apex of the struggle for the common man. Barack Obama, while he is wise enough to see through their charade and the façade has unfinished emotional issues with his mother; he therefore allows Hillary to enter, all the while oblivious to the corruption she reeks of and the deception she radiates.
<span class="break"></span>
So he could have been looking for a symbolic surrogate to please, having Hillary there in The White House in the beginning of his Presidency.
</p>
<p class="h-l">
	H.L. I agree, if so, Hillary Clinton is a very dangerous surrogate mother to pick for Barack Obama.
</p>
<p>
<span class="douglas">Douglas:</span> True. Though I would even take that a step further; Hillary Clinton is a very dangerous surrogate mother for America to have picked.
</p>
<p class="h-l">
	H.L. Yes, and it is just what has happened.
</p>
<p>
<span class="douglas">Douglas:</span> Well tomorrow we are going to get into the neurobiological reasons why that is the case.
</p>
<p class="h-l">
	H.L. Sounds good; really excited about that.
</p>
<p>
<span class="douglas">Douglas:</span> Now however we need to return to Barack Obama.
</p>
<p class="h-l">
	H.L. I have to say though it is really hard not to empathize here with Barack Obama at this moment. Knowing what we know now.
<span class="break"></span>
He is deserted as a kid by his mother. Then he gets into office and like you said he is taken in by this demented mother figure, only 5 years younger than his own mother. He is forced to stop an unstoppable force in The Theorem.
<span class="break"></span>
Hillary then deserts him, “You’re on your own Barack!” Now he is left feeling those pains again, heading to the last place in the world, as you say, he should be going and that is Hawaii where the origins of those emotions started in the first place.
</p>
<p>
<span class="douglas">Douglas:</span> I couldn’t agree more. In fact Hillary may have been more specific and cutting in her criticism of him.
</p>
<p class="h-l">
	H.L. What do you mean?
</p>
<p>
<span class="douglas">Douglas:</span> Well everything is about to fall apart for the Clintons. Her husband, her Bill, is about to be in serious trouble. His legacy will be tarnished beyond repair and he may be looking at spending his last few years in prison. When Hillary’s Bill is in trouble, she will lose her head. And if she is running around saying she is going to take everyone down with her, she will try and effectively cut Barack Obama with every word she can to prompt him into action. She has studied Obama for years, working for him or with him, so she knows him well; she even campaigned against him, and therefore she would have known his weaknesses.
</p>
<p class="h-l">
	H.L. What you are saying then, she is in a good position to hurt him with her words.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and telling him he is on his own is not going to do it. So if she says or even implies that he is worthless, or asks him what good is he? This could be enough to send him over the edge.
</p>
<p class="h-l">
	H.L. I definitely think it was Hillary, she went too far.
</p>
<p>
<span class="douglas">Douglas:</span> Maybe. One thing I am almost sure you are right on though, there is a female behind it. Certainly it makes the most sense.
<span class="break"></span>
While fleeing perceived prosecution and fleeing the vicinity after the inauguration was male-dominated, as we saw in him wanting to go to Necker Island and have Branson fly him via one of his airplanes to safety. That was male-focused, as in Branson he saw a father figure, a protector, someone he could confide in.
<span class="break"></span>
The Caribbean trip however culminated over six months of male-dominated focus. But now, like a bi-annual cycling manic-depressive the switches deep within his limbic regions are depleted of the essential sodium needed to keep his focus on his patriarchal abandonment. Suddenly they malfunction, and his feminine desertions and betrayals rise to surface with the action of a coiled spring.
<span class="break"></span>
Therefore, this time, when he flees to the South Pacific it will be much different. There is nothing but the abyss to await him. Here distance is the only protection he will receive, and this is ultimately his goal on a subconscious level. Distance is the key, as he will travel 6000 miles away from the perceived shame he has experienced or expects to experience at the feminine hands of someone in or very near Washington D.C.
<span class="break"></span>
Barack Obama has no idea what is driving him on a conscious level at this moment, the shame is complete. He will not listen to anyone. Nothing is going to break down those defenses and the childhood barriers. Remember they are hard if not close to impossible to break down, as they were put there by Nature to prevent the child from splintering apart. No one in his vicinity therefore will be able to reach Barack Obama, as the impenetrable biological barriers seat him on that plane in what will literally be a flight of shame.
</p>
<p class="h-l">
	H.L. Well said.
</p>
<p>
<span class="douglas">Douglas:</span> Barack Obama feels worthless, absolutely worthless. Yet ironically, he has just accomplished the greatest feat in front of the curtain, a two-term presidency, the first African-American president ever! Behind the curtains we talked about that yesterday, an amazing accomplishment; he stopped the unstoppable, with <span class="italic">The Legacy Letter</span> and The Theorem.
<span class="break"></span>
It is no matter, his amazing accomplishments, because all he can see is that 5th grader being sent away; hence the power of the human mind to elevate and destroy, often simultaneously.
</p>
<p class="h-l">
	H.L. Then came the tweet?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, then came the tweet on March 4th by President Trump; the tweet was the cog that turned the gear that started the wheel to roll that would ultimately cease moving somewhere in French Polynesia.
<span class="break"></span>
It was what Obama thought was only the beginning of what President Trump was going to disclose. First President Trump would say he had surveillance, and then next the whole cover-up would come out. This is what Barack Obama was convinced was going to happen.
<span class="break"></span>
Then came the tweet, and like the 12 year old me, he ran. But this time he wasn’t coming back.
</p>
<p class="h-l">
	H.L. It was less than a week after the tweet before he left, I think.
</p>
<p>
<span class="douglas">Douglas:</span> It wasn’t very long. I think they began the investigation close to when he left. Maybe a few days after; I know that by March 20th there were news releases coming out of the investigation, of the house meetings and so forth.
</p>
<p class="h-l">
	H.L. So let’s clean this up a little bit here. It’s early March 2017. Just a little over a week after Donald Trump’s tweet of March, 4th, Barack Obama is going to leave for the South Pacific; French Polynesia.
<span class="break"></span>
He will arrive there on March 15th. Before he goes there he will stop in Hawaii to play golf with friends and meet some tech executives, this is on March 14th. And before that on Monday, March 13th he will hold a secretive meeting with tech executives in San Jose, and the day before that he will lunch with Warren Buffet on Sunday in Omaha. Does that match what you have?
</p>
<p>
<span class="douglas">Douglas:</span> To the letter; just running off course here a little bit. It is good to explain where we are at.
</p>
<p class="h-l">
	H.L. The cover story is he is going to work on his book in French Polynesia, but you are saying that this is not the case at all. He is instead going to say his farewells and commit suicide on the island when he arrives or shortly thereafter, as he fears President Trump is going to release more of the cover-up.
</p>
<p>
<span class="douglas">Douglas:</span> Yes that is right. Of course the thought of suicide was horrific. He couldn’t imagine doing it, but he was going to.
<span class="break"></span>
Now you have to really understand Barack Obama to realize the level of class he intends to accomplish this with. He is not going to drive to Pennsylvania or Maryland do this is in a motel and have some maid find him. I know he had Secret Service, but I’m trying to make a point here.
<span class="break"></span>
He is going to go far away from his people, all 300 plus million of them, very far. He doesn’t want an American citizen to be the one to find him. He doesn’t want to cause anymore trauma than he has to. This is very classy, very selfless and very considerate. This is well rehearsed by him, and he begins the steps with grace.
<span class="break"></span>
Now you also need to remember or be reminded that he is a big fan of the Godfather movies. As there is some choreographed drama at play here as well.
</p>
<p class="h-l">
	H.L. That’s right he is.
</p>
<p>
<span class="douglas">Douglas:</span> So he is going to do this up in style. Remember Frank Pentangeli?
</p>
<p class="h-l">
	H.L. Yes, who can forget? He was to testify against Michael Corleone in The Godfather Part II. Then Pentangeli’s’ brother showed up from Italy.
<span class="break"></span>
Tom Hagan comes and talks to Frank Pentangeli and tells him of the Roman Empire and how the traitors can save their families name if they committed suicide. But often they had a party first.
<span class="break"></span>
You think that’s how he planned it?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, that is how he envisioned it. His big party was to go see his friends in Hawaii. Then pick a beautiful location in luxurious surroundings in French Polynesia and commit suicide. I imagine the method was to slit his wrists, as like Pentangeli, he was surrounded by federal agents. Only his were Secret Service, and not the FBI.
</p>
<p class="h-l">
	H.L. A shiver just ran up my back when you said that. I am sure that is it.
</p>
<p>
<span class="douglas">Douglas:</span> Of course it is. And just to make sure that everyone knows it, as he views the press as simple-minded and overly obedient, he will leave another big clue or crumb.
</p>
<p class="h-l">
	H.L. What?
</p>
<p>
<span class="douglas">Douglas:</span> He is going to stay at The Brando; the hotel once owned by the star of the Godfather; Marlon Brando.
</p>
<p class="h-l">
	H.L. That’s right, I remember. Why didn’t anyone else see this?
</p>
<p>
<span class="douglas">Douglas:</span> I have no idea.
</p>
<p class="h-l">
	H.L. That is so accurate he left a lot of clues to his intentions. But why, was he playing a game with the world?
</p>
<p>
<span class="douglas">Douglas:</span> No, I just think it was another example of his selfless thinking.
<span class="break"></span>
Remember he is surrounded by Secret Service agents. These people have become his friends and they will get blamed, or blame themselves, if this looks like an impulsive act.
</p>
<p class="h-l">
	H.L. Now that makes sense. I have never in my life heard something so disturbing, but at the same time so real.
<span class="break"></span>
He was in bad shape.
</p>
<p>
<span class="douglas">Douglas:</span> Of course, now he stopped somewhere before he gets to his party in Hawaii, as you said.
</p>
<p class="h-l">
	H.L. Yes he did. He stopped two places actually.
</p>
<p>
<span class="douglas">Douglas:</span> Now this first action or first stop can be interpreted in two ways. I will give you both.
<span class="break"></span>
When he stopped by for a ‘secret meeting’ with the tech executives and the other with Warren Buffet, he very well may have been thanking them. This would have been very classy. This would have been in accordance with the entire production.
</p>
<p class="h-l">
	H.L. Makes sense; the other?
</p>
<p>
<span class="douglas">Douglas:</span> It could have been like saluting a captain on the battlefield. You know the results of that correct?
</p>
<p class="h-l">
	H.L. Sure because you just signed the captain’s death warrant as the snipers will take him out.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly. He could have been leaving crumbs, saluting Warren Buffet.
</p>
<p class="h-l">
	H.L. That would have been the rebellious Obama, one last chance to save face in humanity by exposing his co-conspirators.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, because you know there is going to be an investigation and this will all come out. So what better way to redeem yourself; what better way to ensure the protection of the ones left behind than by exposing some of the lieutenants of this whole rancid affair?
</p>
<p class="h-l">
	H.L. Yes, after all he didn’t start this. So are you going to disclose to them the tech billionaires?
</p>
<p>
<span class="douglas">Douglas:</span> No, I already know who most of them are. They have been dogging me for years. They are irrelevant; they are what I worked so hard for 25 years to never become.
<span class="break"></span>
But I know a man who now lives on Pennsylvania Avenue who is going to be very interested in their names.
</p>
<p class="h-l">
	H.L. Because they have been financing the coup?
</p>
<p>
<span class="douglas">Douglas:</span> Yes they have been, and have made the presidents last four years hell.
<span class="break"></span>
All their silly billionaire reading lists are not going to help them now; for they forgot to learn the one primary lesson of history.
</p>
<p class="h-l">
	H.L. What is that?
</p>
<p>
<span class="douglas">Douglas:</span> Don’t Fuck With The King!
</p>
<p class="h-l">
	H.L. Couldn’t have stated it better myself. I should have noticed you were setting me up for that one.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it is the one rule. And while Trump may consider leniency for Barack Obama, I doubt there will be any leniency for the businessmen behind Obama.
</p>
<p class="h-l">
	H.L. They have too much money to be that stupid.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well-spoken, and it really was a coup as you will see.
</p>
<p class="h-l">
	H.L. So where were we?
</p>
<p>
<span class="douglas">Douglas:</span> He is allowed to go to the worst place in the world really.
</p>
<p class="h-l">
	H.L. What do you mean, I have seen pictures it is beautiful.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but you read The Theorem; you know how intimidating Nature can be.
<span class="break"></span>
That is the worst scene to play out that psychodrama. Anything that reminds you of the awesome power of Nature uncontrolled can reignite those origins we all experienced. This includes the process of birth itself, of which suicide is a reenactment of.
</p>
<p class="h-l">
	H.L. Yes, I see that. So he would have been better off going to say Central Park?
</p>
<p>
<span class="douglas">Douglas:</span> That would be the perfect place. To see Nature controlled like that should suppress those impulses, more so than the dominance of Nature he experienced. In theory at least, now I don’t know if such statistics would support that.
<span class="break"></span>
But I would have to think that overwhelming swath of beauty would have to make one feel powerless and insignificant. It would me.
</p>
<p class="h-l">
	H.L. He was already feeling that way, as you said: to experience more of that would have not been good.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, so you go from feeling powerless in the manmade world, losing your throne essentially to feeling powerless in the natural world.
<span class="break"></span>
I don’t know; it’s interesting. Maybe then in a way that is what he needed. I am not sure now, I’m riddled, and it is not something I should be riddled by.
</p>
<p class="h-l">
	H.L. You’re probably tired; it has been a long day.
</p>
<p>
<span class="douglas">Douglas:</span> It’s been a long four days, and we have a ways to go.
</p>
<p class="h-l">
	H.L. Then the celebrities come.
</p>
<p>
<span class="douglas">Douglas:</span> Yes and no. You see at first I saw no evidence that Michelle Obama showed up on the island, it wasn’t on any search engines; now I see that she was there on April 8th. So, first his wife came to try and rescue him from his suicide.
</p>
<p class="h-l">
	H.L. Well if you couldn’t find anything on it before, and I trust you searched thoroughly as this is well researched, you’re summary. Perhaps they wanted to keep it out of the press.
</p>
<p>
<span class="douglas">Douglas:</span> I think so. And that is their business, they should be allowed privacy. No one wants to violate that.
</p>
<p class="h-l">
	H.L. But when there is a potential suicide involved of a president?
</p>
<p>
<span class="douglas">Douglas:</span> Then all bets are off. Then it becomes a country’s business, it's one thing you surrender when you become president. So yes, his wife arrived there first.
</p>
<p class="h-l">
	H.L. She still loved him.
</p>
<p>
<span class="douglas">Douglas:</span> Of course she did and does. Likely there she talked him down: some.  She likely talked him out of it: some. Hopefully they had mental health professionals available to them, though I doubt they utilized them. She reminded him that the investigation was going in his favor, and there was no need to give up.
</p>
<p class="h-l">
	H.L. So by the way you are sounding, it wasn’t enough for him. So then she called in the celebrities to help.
</p>
<p>
<span class="douglas">Douglas:</span> Michelle Obama is not a crisis counselor. Obama is still sick, and whatever point she makes, he is going to counter with five points to drain every piece of compassion out of her. He is a bottomless pit at this point. Everything is coming to the surface; the desertion by his mother, by his father, all of it.
</p>
<p class="h-l">
	H.L. It is too much for her to handle alone, so she calls in the celebrities for help.
</p>
<p>
<span class="douglas">Douglas:</span> I think at that point, likely you are right on target.
<span class="break"></span>
She might have needed someone to support her so that she could support him, as he was likely emptying everything out of her. No woman, no matter how strong can cope with a man who has suppressed his abuse for close to fifty years and now suddenly it fires explosively in every direction.
</p>
<p class="h-l">
	H.L. True.
</p>
<p>
<span class="douglas">Douglas:</span> It kind of busted up the facade that he would be there a few months working on a book, the celebrities coming though.
<span class="break"></span>
I don’t think he was there more than three or maybe four weeks and then they showed up. If I was really working on a book down there, I would have sent the celebrities away.
</p>
<p class="h-l">
	H.L. I imagine you would. I could see that.
</p>
<p>
<span class="douglas">Douglas:</span> The whole scenario was bizarre.
</p>
<p class="h-l">
	H.L. Just what you need when you have problems, people with more problems, celebrities are loaded with them. “Quick everyone jump in this sinking rowboat!”
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it was a poorly hatched plan at best. But they obviously cheered him up.
</p>
<p class="h-l">
	H.L. I know that one of the celebrities that were there, Oprah, said, “What happened on the boat stays on the boat.” This was in response to questions about their journey to visit Obama.
<span class="break"></span>
After listening to this, it sounds ominous, that statement.
</p>
<p>
<span class="douglas">Douglas:</span> I heard that as well. Yes, that’s extremely ominous.
<span class="break"></span>
But it worked. They did a good job, really they did. I am sure they are proud; someone down there saved a presidents life. Maybe they were all in on it.
</p>
<p class="h-l">
	H.L. You think President Trump cares which celebrities are there that helped Obama? I doubt it, myself.
</p>
<p>
<span class="douglas">Douglas:</span> No, he knows the story; he has been around many celebrities. He is well aware I am sure how fragile that existence is. Just the money, it’s all these billionaires follow. They follow the money to the head of the snake.
</p>
<p class="h-l">
	H.L. So it was a good sign when he went to Indonesia. He was getting better. That’s what you said.
</p>
<p>
<span class="douglas">Douglas:</span> Definitely a good sign. You know at first I misinterpreted the entire string of events. I figured well, he was fleeing. This made the most sense initially.
<span class="break"></span>
If he would have gone straight to Indonesia, I would have bought that, as they have no extradition treaty with the U.S. But then, well, you know, it looked bad.
<span class="break"></span>
So it was steps to his recovery really. Start off with the goodbye tour, head to Suicide Island, wife and friends to the rescue, and then off to improving mental health where he can’t be extradited. He would have quite a book in him, if he was brave enough to ever disclose the truth.
</p>
<p class="h-l">
	H.L. That’s a good point. Do you think the Clintons sent the celebrities, maybe through third party communications? “Hey, he’s in trouble, get down there!”
</p>
<p>
<span class="douglas">Douglas:</span> Or his wife. I still think like you said it was his wife.
</p>
<p class="h-l">
	H.L. Yes, I think so.
</p>
<p>
<span class="douglas">Douglas:</span> You know if President Trump would have sent one more tweet, had any more information to disclose, or revealed one more piece of the puzzle in regards to this wiretapping and cover-up. Likely that would have been enough to push Barack Obama over the edge.
<span class="break"></span>
We, as a nation, really came that close to losing a President by one of the foulest means imaginable.
</p>
<p class="h-l">
	H.L. It makes you wonder doesn’t it?
</p>
<p>
<span class="douglas">Douglas:</span> Well, yes. You have to give President Trump the benefit of the doubt. He is a man in his seventies, he has likely seen many men on the verge of suicide and it is possible, he said enough is enough; and released nothing more.
<span class="break"></span>
It certainly makes you wonder. Barack Obama was certainly convinced more was going to come out.
<span class="break"></span>
Why would that be?
</p>
<p class="h-l">
	H.L. You have to consider every aspect, every possible scenario and that certainly could have been one of them.
</p>
<p>
<span class="douglas">Douglas:</span> Okay, so now take a deep breath, as you would tell me, and take that all in. Our former President Barack Obama just escaped a close call with his own death in The South Pacific. Unless you can fully realize the shockwaves that this sent to the very few elite at the pinnacle of power within the Democratic Party, the rest of these events will make little sense.
</p>
<p class="h-l">
	H.L. I was thinking, just an idea. But, what about wrapping it up early this evening and saving the remainder of the questions or the narrative for tomorrow. Would that throw you off too much?
</p>
<p>
<span class="douglas">Douglas:</span> No, it will just make tomorrow exceedingly long.
<span class="break"></span>
At the same time, we have been deep into a large amount of recent U.S. History today. A president on the verge of suicide will be a lot for the reader to fathom and ultimately digest. Hopefully those in charge of mental health policy in this country will do some soul searching and realize that Barack Obama’s actions while unique because of his position; were not unique to the masses he once led. And if nothing else good comes from this, at least it should be a wakeup call to us all as a Nation.
</p>
<p class="h-l">
	H.L. I agree. I feel it would be respectful to not only the former president, but to the presidency itself to wrap it up for tonight here. If we just plow through all of this and into the cover-up; well it does not seem right.
</p>
<p>
<span class="douglas">Douglas:</span> I will not argue with that. So we will leave the rest for tomorrow?
</p>
<p class="h-l">
H.L. Yes; until tomorrow.
</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {

	}
</script>

<style scoped>

</style>